{
  "app_version_modal.title": "Mise à jour requise",
  "app_version_modal.text": "Une mise à jour de l'application est nécessaire pour assurer son bon fonctionnement. Veuillez recharger la page.",
  "app_version_modal.update": "Actualiser pour mettre à jour",
  "legacy_dashboard_notice_banner.title": "L'ancien dashboard Wino a fermé",
  "legacy_dashboard_notice_banner.text": "Vous retrouvez ici, sur app.wino.fr, vos données dans une application plus rapide et plus complète. Les quelques fonctionnalités manquantes arrivent prochainement. Pensez à mettre à jour vos favoris !",
  "customer_form_page.added_address.text": "L'adresse du siège social a été ajoutée à partir du SIRET renseigné. Vérifiez-la avant d'enregistrer.",
  "customer_form_page.billing_country_mismatch.title": "Pays de facturation différent de l'adresse",
  "customer_form_page.billing_country_mismatch.text": "Le pays de l'adresse de facturation ({{addressCountry}}) ne correspond pas à celui sélectionné dans le bloc Facturation ({{billingCountry}}).",
  "customer_form_page.overwritten_value.text": "Ancienne valeur : {{value}}",
  "customer_form_page.overwritten_value.restore": "Rétablir",
  "customer_form_page.price_fieldset.empty_placeholder": "Aucune grille tarifaire n’existe pour la boutique « {{shop}} »",
  "customer_form_page.loyalty_subscription.toggle.label": "Inscrire au programme de fidélité, le client a été informé de ses conditions",
  "customer_form_page.loyalty_subscription.welcome_points": "{{points}} offerts à l’inscription",
  "customer_form_page.loyalty_subscription.failure": "Le client a été créé mais son inscription au programme de fidélité a échoué : {{error}}",
  "customer_form_page.loyalty_subscription.email_banner.text": "L’adresse e-mail est nécessaire pour inscrire le client au programme de fidélité. Nous recommandons également de renseigner sa date de naissance.",
  "customer_form_page.siret_duplicate.text": "Ce SIRET est déjà utilisé par ",
  "customer_form_page.siret_duplicate.unnamed": "voir la fiche",
  "catalog_variant.sku_duplicate.text": "Ce SKU est déjà utilisé par ",
  "company_suggestion.title": "Suggestion d'établissement",
  "company_suggestion.title.tooltip_text": "Cet établissement a été trouvé dans l'annuaire des entreprises à partir des informations de cette fiche client.\nLa suggestion peut être incorrecte, vérifiez le SIRET.",
  "company_suggestion.use_button.label": "Utiliser",
  "company_suggestion.use_button.tooltip_text": "Mettre à jour avec les informations de cet établissement",
  "company_suggestion.form_use_button.label": "Utiliser cette suggestion",
  "company_suggestion.form_use_button.tooltip_text": "Renseigner le SIRET de cet établissement, et compléter les informations manquantes",
  "company_suggestion.annuaire_link_button.tooltip_text": "Voir dans l'annuaire",
  "customer_details_page.information_card.list_line.siret.label": "N° SIRET",
  "customer_details_page.information_card.list_line.siren.label": "N° SIREN",
  "customer_details_page.loyalty_card.subscribe_text_action": "Inscrire le client ?",
  "customer_details_page.loyalty_card.see_loyalty_tooltip": "Voir la fidélité",
  "customer_details_loyalty.points_edit_modal.description": "Si votre client ne dispose pas du nombre de points de fidélité souhaité, vous pouvez le modifier manuellement.",
  "customer_details_loyalty.points_edit_modal.points_field.label": "Nouveau solde",
  "customer_details_loyalty.points_edit_modal.points_field.placeholder": "Entrez le nouveau solde de points",
  "customer_details_loyalty.subscribe_modal.title": "Confirmation d’inscription",
  "customer_details_loyalty.subscribe_modal.description": "Merci de compléter / vérifier ces informations pour confirmer l’inscription au programme de fidélité.",
  "customer_details_loyalty.subscribe_modal.email_field.label": "Adresse e-mail",
  "customer_details_loyalty.subscribe_modal.date_of_birth_field.label": "Date de naissance",
  "customer_details_loyalty.subscribe_modal.consent_field.text": "Le client a été informé des conditions du programme de fidélité.",
  "customer_details_loyalty.subscribe_modal.consent_field.error": "Le client doit avoir été informé des conditions.",
  "customer_details_loyalty.subscribe_modal.welcome_points.reminder": "Et n’oubliez pas de rappeler à votre client que des points lui sont offerts à l’inscription !",
  "customer_details_loyalty.subscribe_modal.welcome_points.title": "{{points}} offerts",
  "customer_details_loyalty.subscribe_modal.welcome_points.subtitle": "Offre à l’inscription",
  "customer_details_loyalty.subscribe_modal.commit_button.label": "Confirmer inscription",
  "selected": "sélectionné(s)",
  "Go to previous": "Aller au précédent",
  "Go to next": "Aller au suivant",
  "Archiving": "Archivage",
  "Tenure": "Ancienneté",
  "New customer": "Nouveau client",
  "{{months}} {{month}}": "{{months}} {{month}}",
  "{{years}} {{year}} and {{months}} {{month}}": "{{years}} {{year}} et {{months}} {{month}}",
  "Addresses": "Adresses",
  "No specified address": "Aucune adresse renseignée",
  "Misc": "Autres",
  "Mobile": "Portable",
  "Metadata": "Métadonnées",
  "Copy": "Copier",
  "Copied to clipboard!": "Copié dans le presse-papiers !",
  "Enabled{{feminine}}": "Activée",
  "Inactive{{feminine}}": "Inactive",
  "Available": "Disponible",
  "Elec. invoicing address": "Adresse FE",
  "Intracommunity VAT": "TVA intracommunautaire",
  "electronic_invoicing.card.title": "Facturation électronique",
  "electronic_invoicing.card.settings_button_tooltip.text": "Voir paramètres",
  "electronic_invoicing.coming_soon_badge.table_cell.tooltip.text": "La facturation électronique débarque bientôt chez Wino !",
  "electronic_invoicing.settings.enrollment_status.pending_label": "Inscription non finalisée",
  "electronic_invoicing.settings_request.failure": "Les paramètres de facturation électronique n'ont pas pu être récupérés. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.settings_request.unexpected_failure": "Une erreur inattendue est survenue lors de la récupération des paramètres de facturation électronique. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.setup_request.failure": "Le compte eFacture n'a pas pu être créé. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.setup_request.already_linked_siret_failure": "Le compte eFacture n'a pas pu être créé car le SIRET renseigné est déjà associé à une autre boutique.",
  "electronic_invoicing.setup_request.already_linked_vat_number_failure": "Le compte eFacture n'a pas pu être créé car le numéro de TVA renseigné est déjà associé à une autre boutique.",
  "electronic_invoicing.taxation_regime.basic_vat_exemption": "Franchise en base",
  "electronic_invoicing.taxation_regime.simplified": "Réel simplifié (disparaît dès 2027)",
  "electronic_invoicing.taxation_regime.normal_monthly": "Réel normal - mensuel",
  "electronic_invoicing.taxation_regime.normal_quarterly": "Réel normal - trimestriel",
  "electronic_invoicing.taxation_regime.other": "Autre",
  "electronic_invoicing.employees_number.at_least_251": "251 et plus",
  "electronic_invoicing.setup_request.unexpected_failure": "Une erreur inattendue est survenue lors de la création du compte eFacture. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.download_contract_request.failure": "Le contrat eFacture n'a pas pu être téléchargé. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.update_settings_request.failure": "Les paramètres de facturation électronique n'ont pas pu être mis à jour. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.update_settings_request.unexpected_failure": "Une erreur inattendue est survenue lors de la mise à jour des paramètres de facturation électronique. Veuillez réessayer ou contacter le support.",
  "electronic_invoicing.inactive_card_content.help_center_button.label": "Qu'est-ce que la facturation électronique ?",
  "settings_electronic_invoicing_page.notification_success.address_updated": "L'adresse de facturation électronique a bien été mise à jour.",
  "settings_electronic_invoicing_page.account_status_fieldset.content.title": "Mon compte eFacture",
  "settings_electronic_invoicing_page.account_status_fieldset.content.subtitle.login_name": "identifiant : ",
  "settings_electronic_invoicing_page.account_status_fieldset.content.header.button_label": "Voir mon compte",
  "settings_electronic_invoicing_page.account_status_fieldset.content.issuing.title": "Émission des factures",
  "settings_electronic_invoicing_page.account_status_fieldset.content.issuing.missing_invoicing_address_badge.label": "Aucune adresse FE",
  "settings_electronic_invoicing_page.account_status_fieldset.content.issuing.description": "Le service d'émission est activé, l'envoi des factures est automatique (bientôt disponible).",
  "settings_electronic_invoicing_page.account_status_fieldset.content.issuing.belgian_shop.description": "Le service d'émission est activé, l'envoi des factures est automatique.",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.title": "Réception des factures",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.enabled.download_contract_button_label": "Télécharger contrat",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.enabled.description": "Le service de réception est activé, la réception des factures est automatique.",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.disabled.description": "Pour recevoir vos factures avec Wino, enregistrez eFacture dans l'annuaire public.",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.inactive.description": "Pour activer le service de réception des factures avec Wino, veuillez nous contacter.",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.disabled.enroll_button_label": "S'inscrire dans l'annuaire",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.third_party_platform_checkbox.text": "J'utilise une plateforme agréée tierce pour la réception de mes factures",
  "settings_electronic_invoicing_page.account_status_fieldset.content.receiving.third_party_platform_checkbox.belgian_text": "J'ai déjà une adresse de facturation électronique pour la réception de mes factures",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.title": "La facturation électronique prête à l'emploi",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.content.part_1": "La facturation électronique devient progressivement obligatoire. Avec ",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.content.part_2": ", la plateforme agréée partenaire intégrée à Wino (groupe ISAGRI), vous pouvez dès maintenant anticiper cette évolution en activant simplement le service d'émission et de réception des factures.",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.content_caption_part_1": "Inclus dans votre abonnement",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.content_caption_part_2": "dans la limite de 3500 factures émises ou reçues par an.",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.create_button_label": "Créer mon compte eFacture",
  "settings_electronic_invoicing_page.account_setup_fieldset.content.helpcenter_button_label": "Qu'est-ce que la facturation électronique ?",
  "settings_electronic_invoicing_page.guide_fieldset.content.title": "Qu'est-ce que la facturation électronique ?",
  "settings_electronic_invoicing_page.guide_fieldset.content.description.part_1": "La facturation électronique devient progressivement obligatoire. Avec ",
  "settings_electronic_invoicing_page.guide_fieldset.content.description.part_2": ", la plateforme agréée partenaire intégrée à Wino (groupe ISAGRI), vous pouvez dès maintenant anticiper cette évolution en activant simplement le service d'émission et de réception des factures.",
  "settings_electronic_invoicing_page.address_fieldset.title": "Adresse de facturation électronique",
  "settings_electronic_invoicing_page.address_fieldset.description": "Renseignez votre adresse de facturation électronique, si vous en possédez déjà une.",
  "settings_electronic_invoicing_page.address_fieldset.content.input_label": "Adresse de facturation électronique",
  "settings_electronic_invoicing_page.address_fieldset.required_error": "La saisie d'une adresse de facturation électronique est requise.",
  "settings_electronic_invoicing_page.address_fieldset.create_button_label": "Ajouter adresse électronique",
  "settings_electronic_invoicing_page.address_fieldset.edit_banner.title": "Modification d'une adresse déjà enregistrée",
  "settings_electronic_invoicing_page.address_fieldset.edit_banner.text": "La nouvelle adresse remplacera définitivement l'actuelle. Pensez à la communiquer à vos fournisseurs : sans cela, leurs factures continueront d'être envoyées à l'ancienne adresse et ne vous parviendront plus.",
  "settings_electronic_invoicing_page.address_fieldset.helpcenter_article_label": "Comment renseigner mon adresse de facturation électronique ?",
  "settings_electronic_invoicing_page.account_fieldset.title": "Plateforme Agrée eFacture (Cecurity)",
  "settings_electronic_invoicing_page.account_fieldset.description": "Créez votre compte P.A. eFacture (Cecurity) pour activer l'émission et la réception des factures.",
  "settings_electronic_invoicing_page.account_active_fieldset.description": "Votre compte P.A. eFacture (Cecurity) pour l'émission et la réception des factures.",
  "settings_electronic_invoicing_page.account_creation_modal.title": "Créer mon compte eFacture (Cecurity)",
  "settings_electronic_invoicing_page.account_creation_modal.intro_text": "La création de votre compte eFacture (Cecurity) se déroule automatiquement en 3 étapes :",
  "settings_electronic_invoicing_page.account_creation_modal.step_one.label": "‎ ‎ 1. Entreprise - ",
  "settings_electronic_invoicing_page.account_creation_modal.step_one.description": "Renseignez / vérifiez, puis validez les informations de votre société.",
  "settings_electronic_invoicing_page.account_creation_modal.step_two.label": "‎ ‎ 2. Abonnements - ",
  "settings_electronic_invoicing_page.account_creation_modal.step_two.description": "Mise à disposition du service d'émission et de réception des factures.",
  "settings_electronic_invoicing_page.account_creation_modal.step_three.label": "‎ ‎ 3. Utilisateur - ",
  "settings_electronic_invoicing_page.account_creation_modal.step_three.description": "Un premier compte utilisateur est créé automatiquement.",
  "settings_electronic_invoicing_page.account_creation_modal.outro_text": "Vous pourrez ensuite tout gérer depuis votre compte eFacture.",
  "settings_electronic_invoicing_page.account_creation_modal.banner.title": "L'émission & la réception des factures avec eFacture est inclus dans votre abonnement Wino.",
  "settings_electronic_invoicing_page.account_creation_modal.banner.issuing.text_part_1_bold": "• Le service d'émission des factures est mis à disposition et activé en même temps,",
  "settings_electronic_invoicing_page.account_creation_modal.banner.issuing.text_part_2": " suite à la création de votre compte eFacture (Cecurity), vous n'avez rien de plus à faire.",
  "settings_electronic_invoicing_page.account_creation_modal.banner.receiving.text_part_1": "• Le service de réception est quant à lui seulement mis à disposition. ",
  "settings_electronic_invoicing_page.account_creation_modal.banner.receiving.text_part_2_bold": "Pour l'activer et l'utiliser, vous devrez inscrire eFacture en tant que PA de réception dans l'annuaire public.",
  "settings_electronic_invoicing_page.account_creation_modal.form.title": "Informations Entreprise",
  "siret_input_field.label": "Numéro de SIRET",
  "siret_input_field.placeholder": "14 chiffres à saisir",
  "siret_input_field.error_message": "Le numéro doit comporter 14 chiffres.",
  "siret_input_field.verification_status.invalid": "Numéro introuvable",
  "siret_input_field.legal_form.sole_trader.title": "Mention « EI » ajoutée automatiquement",
  "siret_input_field.legal_form.sole_trader.text": "En tant qu'entrepreneur individuel, l'article R. 526-27 du code de commerce vous oblige à faire figurer la mention « EI » dans votre dénomination. Nous l'avons donc ajoutée pour vous.",
  "siret_input_field.legal_form.privacy_right.title": "Dénomination sociale à compléter",
  "siret_input_field.legal_form.privacy_right.text": "Votre droit d'opposition à la diffusion de vos données est actif : nous ne pouvons pas remplir ce champ à votre place. Saisissez votre nom accompagné de la mention d'entrepreneur individuel, sous l'une des trois formes autorisées par l'article R. 526-27 du code de commerce :",
  "siret_input_field.legal_form.privacy_right.example_one": "• Entrepreneur individuel Prénom NOM",
  "siret_input_field.legal_form.privacy_right.example_two": "• Prénom NOM Entrepreneur individuel",
  "siret_input_field.legal_form.privacy_right.example_three": "• EI Prénom NOM ou Prénom NOM EI",
  "electronic_invoicing.invoicing_endpoint.siren.placeholder": "9 chiffres à saisir",
  "electronic_invoicing.invoicing_endpoint.siren.error_message": "Le numéro doit comporter 9 chiffres.",
  "electronic_invoicing.invoicing_endpoint.bce.placeholder": "10 chiffres à saisir",
  "electronic_invoicing.invoicing_endpoint.bce.error_message": "Le numéro doit comporter 10 chiffres.",
  "electronic_invoicing.invoicing_endpoint.vat.placeholder": "10 chiffres précédés de BE",
  "electronic_invoicing.invoicing_endpoint.vat.error_message": "Le numéro doit comporter 10 chiffres précédés de BE.",
  "electronic_invoicing.invoicing_endpoint.complement.error_message": "Saisie requise : lettres et chiffres sans accent, ainsi que - _ et .",
  "bce_input_field.error_message": "Le numéro doit comporter 10 chiffres.",
  "settings_electronic_invoicing_page.account_creation_modal.form.vat_number.label": "Numéro TVA intracommunautaire",
  "settings_electronic_invoicing_page.account_creation_modal.form.vat_number.placeholder": "12 caractères",
  "settings_electronic_invoicing_page.account_creation_modal.form.vat_number.error_message": "Le numéro TVA intracommunautaire doit être renseigné et comporter 12 caractères.",
  "settings_electronic_invoicing_page.account_creation_modal.form.corporate_name.label": "Dénomination sociale entreprise",
  "settings_electronic_invoicing_page.account_creation_modal.form.corporate_name.placeholder": "Saisir le numéro SIRET pour remplir",
  "settings_electronic_invoicing_page.account_creation_modal.form.corporate_name.belgian_placeholder": "Votre Société",
  "settings_electronic_invoicing_page.account_creation_modal.form.email.label": "Adresse e-mail compte eFacture",
  "settings_electronic_invoicing_page.account_creation_modal.form.email.placeholder": "votre.email@entreprise.com",
  "settings_electronic_invoicing_page.account_creation_modal.form.first_name.label": "Prénom responsable légal",
  "settings_electronic_invoicing_page.account_creation_modal.form.first_name.placeholder": "Votre Prénom",
  "settings_electronic_invoicing_page.account_creation_modal.form.last_name.label": "Nom responsable légal",
  "settings_electronic_invoicing_page.account_creation_modal.form.last_name.placeholder": "Votre Nom",
  "settings_electronic_invoicing_page.account_creation_modal.form.taxation_regime.label": "Régime de TVA",
  "settings_electronic_invoicing_page.account_creation_modal.form.taxation_regime.placeholder": "Ex. : Réel normal - trimestriel",
  "settings_electronic_invoicing_page.account_creation_modal.form.employees_number.label": "Nombre d'employés",
  "settings_electronic_invoicing_page.account_creation_modal.form.employees_number.placeholder": "Ex. : 1 – 10 employés",
  "settings_electronic_invoicing_page.account_creation_modal.submit_button_label": "Créer compte eFacture",
  "settings_electronic_invoicing_page.account_creation_modal.spinner_title": "Création du compte eFacture",
  "settings_electronic_invoicing_page.account_creation_modal.success_message": "Le compte eFacture a bien été créé.",
  "app.shop_required_data_alert.title": "Informations de boutique incomplètes",
  "app.shop_required_data_alert.subtitle": "certaines informations obligatoires de la boutique « {{shopName}} » ne sont pas renseignées.",
  "app.shop_required_data_alert.link": "Compléter les informations",
  "settings_shops_page.required_data_validation.message": "Certaines informations obligatoires de votre boutique ne sont pas renseignées. Complétez les champs signalés puis enregistrez.",
  "settings_billing_account_show_page.invoices_card.disclaimer.text": "Les factures émises à partir du 1er juillet 2026 ne sont momentanément plus disponibles ici, mais elles le seront à nouveau prochainement. En attendant, vous pouvez les consulter depuis votre espace",
  "settings_billing_account_show_page.invoices_card.disclaimer.link": "mesfactures.isagri.fr",
  "settings_electronic_invoicing_page.title": "Facturation électronique",
  "electronic_invoicing_workflow_state.label": "Statut P.A.",
  "sales_details_page.electronic_invoicing_card.title": "La facturation électronique arrive !",
  "sales_details_page.electronic_invoicing_card.content": "La facturation électronique devient progressivement obligatoire. Avec eFacture, la plateforme agréée partenaire intégrée à Wino (groupe ISAGRI – CECURITY), vous pourrez prochainement activer le service d'émission des factures directement depuis votre espace.",
  "sales_details_page.electronic_invoicing_card.content_caption": "Inclus dans votre abonnement.",
  "sales_details_page.electronic_invoicing_workflow_state_card.receiving_disabled.title": "Activer la réception des factures ?",
  "sales_details_page.electronic_invoicing_workflow_state_card.receiving_disabled.content": "Enregistrez eFacture comme votre Plateforme Agréée dans l'annuaire public pour recevoir vos factures.",
  "sales_details_page.electronic_invoicing_workflow_state_card.receiving_disabled.button_label": "S'inscrire dans l'annuaire",
  "sales_details_page.electronic_invoicing_workflow_state_card.customer_ei_address.label": "Adresse facturation électronique client",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_skip_reason.b2cInvoice.message": "Les factures destinées à des particuliers ne sont pas concernées par le traitement de facturation électronique.",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.ElectronicInvoicePostPublicationIssue.title": "Echec de publication sur l'annuaire",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.PublishElectronicInvoice.title": "Echec de l'émission vers la P.A.",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.DuplicateElectronicInvoice.title": "Echec de l'émission vers la P.A.",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.MissingUblPartyStreetName.title": "Adresse du client incomplète",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.MissingUblPartyCityName.title": "Adresse du client incomplète",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.InvalidVatIdentificationNumber.title": "Numéro de TVA intracommunautaire invalide",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.MissingVatIdentificationNumber.title": "Numéro de TVA intracommunautaire manquant",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.MissingUblPartyPeppolParticipantEndpoint.title": "Adresse FE manquante",
  "sales_details_page.electronic_invoicing_workflow_state_card.backend_failure.UnexpectedIdentificationIdScheme.title": "Adresse FE incorrecte",
  "Electronic invoicing": "Facturation électronique",
  "Creation": "Création",
  "Birthday": "Anniversaire",
  "To be approved": "À valider",
  "Delivery date": "Date de livraison",
  "Not billed": "Non facturé",
  "Billed": "Facturé",
  "sales_details_page.info_and_conditions_card.title": "Autres",
  "sales_details_page.articles_card.header_banner.old_dashboard.missing_data_text.part_1": "Cette facture a été générée depuis l'ancien dashboard, certaines informations sont donc manquantes et elle est ",
  "sales_details_page.articles_card.header_banner.old_dashboard.missing_data_text.part_2": " exclue du traitement de facturation électronique.",
  "Compound item": "Produit composé",
  "Free-text item": "Produit libre",
  "and": "et",
  "Payment under {{terms}}": "Paiement sous {{terms}}",
  "Invoice is awaiting payment": "La facture est en attente de règlement",
  "Related documents": "Documents liés",
  "No related document": "Aucun document lié",
  "Delivery note": "Bon de livraison",
  "Delivery notes": "Bons de livraison",
  "No memo": "Aucune note",
  "Delivered": "Livré",
  "Not delivered": "Non livré",
  "See document": "Voir document",
  "See customer": "Voir client",
  "no.": "n°",
  "errors report": "rapport d'erreurs",
  "catalog_list_page.centralize_catalog_request.unexpected_failure": "Une erreur inattendue est survenue lors de la tentative de centralisation du catalogue.",
  "catalog_list_page.inventory_export_request.unexpected_failure": "Une erreur inattendue est survenue lors de la tentative d'export de l'inventaire.",
  "An issue when attempting downloading the {{name}} file occurred.": "Une erreur est survenue lors de la tentative de téléchargement du fichier {{name}}.",
  "The {{name}} file has been downloaded successfully.": "Le fichier {{name}} a été téléchargé avec succès.",
  "customer_list_page.export_request.unexpected_failure": "Une erreur inattendue est survenue lors de la tentative de téléchargement du fichier des clients.",
  "customer_list_page.avatar_tooltip.loyalty_program_label": "Programme de fidélité",
  "customer_list_page.avatar_tooltip.loyalty_program_member": "adhérant",
  "customer_list_page.avatar_tooltip.loyalty_program_member_since_prefix": "adhéré le",
  "customer_list_page.avatar_tooltip.loyalty_program_not_member": "non adhérant",
  "customer_list_page.table.business_identifiers_column.title": "Facturation",
  "stock_activity_page.export_request.file_too_large_to_be_exported {{stockActivitiesCount}} {{stockActivitiesLimit}}": "{{stockActivitiesCount}} mouvements sont à exporter,\nle fichier exporté risque d'être trop volumineux.\nVeuillez modifier vos filtres pour lancer l'export\n(maximum {{stockActivitiesLimit}} mouvements).",
  "stock_activity_page.export_request.nothing_to_be_exported": "Aucun mouvement de stock à exporter avec ces filtres.",
  "stock_activity_page.export_request.unexpected_failure": "Une erreur inattendue est survenue lors de la tentative de téléchargement du fichier des mouvements de stock.",
  "sales_list_page_export_modal.export_request.date_range_exceeding_failure": "Les ventes ne peuvent pas être exportées pour une période de plus d'un an.",
  "sales_list_page_export_modal.export_request.unexpected_failure": "Une erreur inattendue est survenue lors de la tentative de téléchargement du fichier des ventes.",
  "Document type": "Type de document",
  "sales_list_page.export_modal.title": "Exporter documents de vente",
  "sales_list_page.export_modal.commit_button": "Exporter le document",
  "backdated": "antidaté",
  "Issued from a receipt": "Émise à partir d'un ticket",
  "Transformed from invoice": "Transformé à partir d'une facture",
  "sale.refund_receipt_reason.cancellation_sale.label": "Annulation de la vente",
  "sale.refund_receipt_reason.cashing_error.label": "Erreur d'encaissement",
  "sale.refund_receipt_reason.product_not_compliant_or_damaged.label": "Produit non conforme ou abîmé",
  "sale.refund_receipt_reason.other_reason.label": "Autre motif",
  "Canceled": "Annulé",
  "Issuing & Due date": "Émission & Échéance",
  "Transformed on {{date}} at {{time}}": "Transformé le {{date}} à {{time}}",
  "Refunded on {{date}} at {{time}}": "Remboursé le {{date}} à {{time}}",
  "Paid on {{date}} (backdated)": "Payé le {{date}} (antidaté)",
  "Paid on {{date}} at {{time}}": "Payé le {{date}} à {{time}}",
  "Delivered on {{date}} at {{time}}": "Livré le {{date}} à {{time}}",
  "Billed on {{date}} at {{time}}": "Facturé le {{date}} à {{time}}",
  "Settled on {{date}} at {{time}}": "Soldé le {{date}} à {{time}}",
  "Archived on {{date}} at {{time}}": "Archivé le {{date}} à {{time}}",
  "Number & related document": "Numéro & document lié",
  "Settled by credit note": "Soldé par avoir",
  "Refund receipts": "Remboursements",
  "Refund receipt": "Remboursement",
  "Refunded": "Remboursé",
  "Cancellation": "Annulation",
  "Overdue": "En retard",
  "Loy'": "Fid'",
  "settled": "soldé",
  "paid": "payé",
  "To collect": "À encaisser",
  "To settle": "À solder",
  "Individual": "Particulier",
  "Business": "Professionnel",
  "Pro": "Pro",
  "No customer registered": "Aucun client renseigné",
  "at {{time}}": "à {{time}}",
  "Sales receipt": "Ticket de caisse",
  "Remainder to pay": "Reste à payer",
  "Payment date": "Date de paiement",
  "Credit notes": "Avoirs",
  "{{count}} products from the imported CSV have not been added to the order, ℹ️ please contact « t.pradelle@cavavin.eu » to activate them.": "{{count}} produits importés n'ont pas pu être ajoutés à la commande, ℹ️ veuillez contacter « t.pradelle@cavavin.eu » pour les activer.",
  "{{count}} product from the imported CSV has not been added to the order, ℹ️ please contact « t.pradelle@cavavin.eu » to activate it.": "{{count}} produit importé n'a pas pu être ajouté à la commande, ℹ️ veuillez contacter « t.pradelle@cavavin.eu » pour l'activer.",
  "analytics_cashflow_page.table.time_column.backdated_invoice_payment.tooltip.text": "Ce paiement est antidaté et l'heure n'est pas précisée.",
  "An unexpected error occured.": "Une erreur inattendue est survenue.",
  "Wino could not connect to your printer via the StarPrinter Online service.": "Wino n’a pas réussi à se connecter à votre imprimante via le service StarPrinter Online.",
  "Setup the printer": "Configurer l'imprimante",
  "accounting_page.export_confirmation_modal.title": "Avertissement avant export",
  "accounting_page.export_confirmation_modal.text": "Les écritures comptables générées par Wino sont destinées à aider à la saisie dans votre logiciel comptable.\nElles constituent un outil de préparation, mais ne remplacent pas la validation par un expert-comptable.\n\nAvant toute utilisation, faites-les vérifier par votre professionnel comptable. Ces écritures ne doivent pas être utilisées telles quelles pour des déclarations fiscales.\n\nWino ne saurait être tenu responsable d’une utilisation non conforme des données exportées.",
  "order_cart.table.vat_total_column.product_tax_cell.subtext": "TVA produit",
  "order_cart.cart_options.tax_application.toggle_switch.label": "Exonération de la TVA",
  "catalog_list.stock_cell.thresholds_button_tab.disabled_tooltip_text": "Actuellement, Wino ne prend pas encore en charge les seuils de commande pour les produits de gestion en vrac.",
  "Automatic order": "Commande automatique",
  "Learn more": "En savoir plus",
  "catalog_list.stock_cell.thresholds_tab.info_banner.text_content_1": "En définissant ces 3 seuils Wino ajoutera ensuite, via le bouton « Créer commande automatique » page commande fournisseur, chaque référence dont le stock est ",
  "catalog_list.stock_cell.thresholds_tab.info_banner.text_content_2": " au ",
  "catalog_list.stock_cell.thresholds_tab.info_banner.text_italic_1": "Seuil déclenchant la commande",
  "catalog_list.stock_cell.thresholds_tab.info_banner.text_content_3": " et pré-remplira la quantité pour remonter jusqu'au ",
  "catalog_list.stock_cell.thresholds_tab.info_banner.text_italic_2": " Seuil maximum.",
  "catalog_list.stock_cell.thresholds_tab.minimum_threshold_input.tooltip_content_1": "Lorsque le stock atteint ou passe sous ce seuil, votre stock est signalé par une ",
  "catalog_list.stock_cell.thresholds_tab.minimum_threshold_input.tooltip_bold_1": "pastille rouge",
  "catalog_list.stock_cell.thresholds_tab.minimum_threshold_input.tooltip_content_2": " : il indique un risque de rupture pouvant entraîner une perte de ventes si un client souhaite acheter ce produit.",
  "catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_1": "Entre le ",
  "catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_italic_1": "seuil minimum",
  "catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_2": " et celui-ci, votre stock est signalé par une ",
  "catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_bold_1": "pastille jaune",
  "catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_3": " : il indique qu’il est conseillé de passer une commande fournisseur.",
  "catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_4": "Ce produit est ajouté lors d'une commande automatique.",
  "catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_1": "Entre le ",
  "catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_italic_1": "seuil déclenchant la commande",
  "catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_2": " et celui-ci, votre stock est signalé par une ",
  "catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_bold_1": "pastille verte",
  "catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_3": " : il correspond au niveau maximal recommandé pour éviter le surstockage.",
  "catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_4": "C’est la quantité visée de votre stock après réapprovisionnement d'une commande automatique.",
  "Maximum threshold": "Seuil maximum",
  "Minimum threshold": "Seuil mimimum",
  "Threshold triggering the order": "Seuil déclenchant la commande",
  "Movements": "Mouvements",
  "Thresholds": "Seuils",
  "Enter text...": "Entrer texte...",
  "Restricted access": "Accès restreint",
  "access_denied_page.title.text": "L'accès à cette page n'est pas autorisé",
  "access_denied_page.subtitle.text": "Demandez à un administrateur l'autorisation de consulter cette page.",
  "catalog_variant_page.retail_price_card.banner.text": "Pour accéder aux fonctionnalités avancées de gestion des prix de vente (coefficient, calcul basé sur le coût d'achat, etc), veuillez modifier les prix depuis la page principale du catalogue. L'édition sur cette page variante est simplifiée et ne propose pas ces options avancées.",
  "catalog_list.pricing_settings.section_1.banner.text": "L'indicateur de rentabilité est modifiable en cliquant sur la cellule du prix de vente d'un produit.",
  "order_cart.global_fee_picker_modal.info_banner": "Toute modification des prix ou des quantités du panier nécessite de renouveler cette étape.",
  "Gross purchase price": "Prix d'achat brut",
  "Net purchase price": "Prix d'achat net",
  "Gross full PP": "PA chargé brut",
  "Net full PP": "PA chargé net",
  "Gross acq. cost": "Coût d'achat brut",
  "Net acq. cost": "Coût d'achat net",
  "catalog_list.purchase_price_cell.dialog.section_before_charges": "Prix d'achat avant charges",
  "catalog_list.purchase_price_cell.dialog.section_before_charges.input_label.gross": "Prix d'achat non chargé brut",
  "catalog_list.purchase_price_cell.dialog.section_before_charges.input_label.net": "Prix d'achat non chargé net",
  "catalog_list.purchase_price_cell.full_purchase_price_calculating_method_dialog.section_final.input_label.gross": "Prix d'achat chargé brut",
  "catalog_list.purchase_price_cell.full_purchase_price_calculating_method_dialog.section_final.input_label.net": "Prix d'achat chargé net",
  "catalog_list.purchase_price_cell.acquisition_cost_calculating_method_dialog.section_final.input_label.gross": "Coût d'achat brut",
  "catalog_list.purchase_price_cell.acquisition_cost_calculating_method_dialog.section_final.input_label.net": "Coût d'achat net",
  "catalog_list.price_cell.dialog.section_charges": "Charges",
  "catalog_list.purchase_price_cell.dialog.section_charges.transport_fee.input_label": "Frais transport",
  "catalog_list.purchase_price_cell.dialog.section_charges.taxes_fee.input_label": "Taxes",
  "catalog_list.purchase_price_cell.dialog.section_charges.other_fee.input_label": "Autres frais",
  "catalog_list.retail_price_cell.dialog.section_charges.transport_fee.input_label": "Frais transport HT",
  "catalog_list.retail_price_cell.dialog.section_charges.transport_fee.input_label.shorten": "Fr. transport HT",
  "catalog_list.retail_price_cell.dialog.section_charges.taxes_fee.input_label": "Taxes HT",
  "catalog_list.retail_price_cell.dialog.section_charges.other_fee.input_label": "Autres frais HT",
  "catalog_list.purchase_price_cell.dialog.section_final": "Prix d'achat final",
  "catalog_list.purchase_price_cell.dialog.commit_button_text": "Valider prix d'achat",
  "Gross margin": "Marge brute",
  "catalog_list.retail_price_cell.dialog.section_before_charges": "Prix de vente avant charges",
  "catalog_list.retail_price_cell.dialog.section_before_charges.margin.input_label": "Marge brute",
  "catalog_list.retail_price_cell.dialog.section_before_charges.price_excluding_tax.input_label": "Prix de vente non chargé HT",
  "catalog_list.retail_price_cell.dialog.section_before_charges.price_including_tax.input_label": "Prix de vente non chargé TTC",
  "catalog_list.retail_price_cell.dialog.section_final": "Prix de vente final",
  "catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label": "Prix de vente HT",
  "catalog_list.retail_price_cell.dialog.section_final.price_including_tax.input_label": "Prix de vente TTC",
  "catalog_list.retail_price_cell.dialog.commit_button_text": "Valider prix de vente",
  "By default": "Par défaut",
  "Coefficient": "Coefficient",
  "catalog_list.pricing_settings.section_1.radio_1.title": "Coefficient",
  "catalog_list.pricing_settings.section_1.radio_1.description": "Prix de vente ÷ Prix d'achat",
  "catalog_list.pricing_settings.section_1.radio_2.title": "Tx Marque",
  "catalog_list.pricing_settings.section_1.radio_2.description": "Marge ÷ Prix de vente HT × 100",
  "catalog_list.pricing_settings.section_1.radio_3.title": "Tx Marge",
  "catalog_list.pricing_settings.section_1.radio_3.description": "Marge ÷ Prix d'achat × 100",
  "catalog_list.pricing_settings.section_1.tooltip": "L'indicateur sélectionné est affiché sur l'interface du catalogue par produit.",
  "catalog_list.pricing_settings.section_2.tooltip": "Sélectionner le format de prix d’achat souhaité, avec ou sans remise. Le format choisi est pris en compte pour définir le prix d'achat associé à la méthode de calcul du prix de vente.",
  "catalog_list.pricing_settings.section_3.tooltip": "Sélectionner la méthode adaptée pour calculer la marge et le prix de vente par produit.",
  "catalog_list.pricing_settings.section_3.radio_1.tooltip": "Vous margez uniquement sur le prix d’achat du produit.\nLes autres frais (transport, taxes, etc.) sont ajoutés après coup pour obtenir le prix de vente final.",
  "catalog_list.pricing_settings.section_3.radio_2.tooltip": "Vous margez sur le prix d’achat, les taxes et les autres frais. Les frais de transport sont ajoutés après coup pour obtenir le prix de vente final.",
  "catalog_list.pricing_settings.section_3.radio_3.tooltip": "Vous margez sur l’ensemble des coûts liés à l’achat du produit, incluant le prix d’achat ainsi que tous les frais associés tels que le transport, les taxes et autres frais.",
  "catalog_list.pricing_settings.section_2.radio_1.description": "Prix d'achat sans remise.",
  "catalog_list.pricing_settings.section_2.radio_2.description": "Prix d'achat avec remise.",
  "catalog_list.pricing_settings.section_3.radio_1.description": "Vous margez uniquement sur le prix d’achat.",
  "catalog_list.pricing_settings.section_3.radio_2.description": "Vous margez sur le prix d’achat, les taxes et autres frais.",
  "catalog_list.pricing_settings.section_3.radio_3.description": "Vous margez sur tous les frais associés au prix d’achat.",
  "Net": "Net",
  "Gross": "Brut",
  "Full purchase price": "Prix d'achat chargé",
  "Acquisition cost": "Coût d'achat",
  "Coming soon": "Bientôt disponible",
  "catalog_list.pricing_settings.section_1.title": "Indicateur de rentabilité",
  "catalog_list.pricing_settings.section_2.title": "Format du prix d'achat",
  "catalog_list.pricing_settings.section_3.title": "Méthode de calcul du prix de vente",
  "Save settings": "Enregistrer paramètres",
  "order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.label_1": "Par unité :",
  "order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.content_1": "Les frais sont répartis par ligne en fonction\ndes quantités achetées.",
  "order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.label_2": "Prorata du prix :",
  "order_cart.global_fee_picker_modal.allocation_of_costs.tooltip.content_2": "Les frais sont répartis par ligne en fonction\ndes prix d'achat.",
  "Allocation of costs": "Répartition des frais",
  "Price prorata": "Prorata du prix",
  "Per unit": "Par unité",
  "Apply": "Appliquer",
  "Global shipping costs": "Frais de transport globaux",
  "order_cart.actions_bar.allocation_of_costs.text_button": "Répartir frais transp. globaux",
  "Shop type": "Type de boutique",
  "Independent": "Indépendant",
  "Integrated": "Intégré",
  "Franchised": "Franchisé",
  "Affiliated": "Affilié",
  "Warehouse": "Entrepôt",
  "No price list found": "Aucune grille tarifaire trouvée",
  "All but reset": "Tous sauf réinit.",
  "Not specified": "Non renseigné",
  "Unassigned": "Non assigné",
  "Producer & Supplier": "Producteur & Fournisseur",
  "Creation date": "Date de création",
  "Current stock": "Stock actuel",
  "Categories": "Catégories",
  "Producers": "Producteurs",
  "Regions": "Régions",
  "Please select a shop beforehand.": "Veuillez d'abord sélectionner une boutique.",
  "Cash registers": "Caisses",
  "Services": "Services",
  "Select a device": "Sélectionner un appareil",
  "Device": "Appareil",
  "Devices": "Appareils",
  "The label sheet has been generated, some incorrect barcodes cannot be displayed.": "La planche d'étiquettes a bien été générée, des code-barres erronés ne peuvent être affichés.",
  "Transformed into invoice at": "Transformé en facture à",
  "Filters": "Filtres",
  "Transformed into invoice": "Transformé en facture",
  "Mixed payment": "Paiement combiné",
  "Entering an address": "Saisir une adresse",
  "The previously selected supplier cannot be found (archived).": "Le fournisseur précédemment sélectionné est introuvable (archivé).",
  "Operations": "Opérations",
  "Flow type": "Type de flux",
  "Flow types": "Types de flux",
  "Receipts & refunds": "Tickets & remboursements",
  "Invoices & credit notes": "Factures & avoirs",
  "Cash activities": "Mouvements de caisse",
  "Search an information, time, amount...": "Rechercher une information, heure, montant...",
  "as of": "au",
  "A day starts at 5:00am and ends at 4:59am the next day to include all your sales, even if you close late.": "Une journée débute à 5h00 et se termine à 4h59 le lendemain afin d'inclure toutes vos ventes, même en cas de fermeture tardive.",
  "Bank Transfer": "Virement",
  "Bank transfer": "Virement",
  "Cheque": "Chèque",
  "Cash": "Espèces",
  "Amex - CTLS": "Amex - SC",
  "DC - CTLS": "CB - SC",
  "Amex contactless": "Amex sans contact",
  "Debit Card contactless": "CB sans contact",
  "Credit Note": "Avoir",
  "Distance Selling": "Vente à distance",
  "Dist. sell.": "VAD",
  "Debit Card": "Carte Bancaire",
  "DC": "CB",
  "Gift voucher": "Chèque cadeau",
  "Council voucher": "Chèque mairie",
  "Inflow": "Entrée",
  "Outflow": "Sortie",
  "No. & type of flow": "N° & type de flux",
  "Customer / Comment": "Client / Commentaire",
  "Seller": "Vendeur.se",
  "Source": "Source",
  "Cash flow": "Flux de trésorerie",
  "No French address suggestion": "Aucune suggestion d'adresse Française",
  "Suggested French addresses": "Suggestions d'adresses Françaises",
  "Commit settings": "Valider paramètres",
  "Set labels settings": "Paramètrer l'impression d'étiquettes",
  "Print parameters set correctly!": "Paramètres d'impression bien renseignés !",
  "(generate automatically if missing)": "(générer automatiquement si manquant)",
  "[Monitor printing from your StarPrinter Online account]({{link}})": "[Suivre l'impression depuis votre compte StarPrinter Online]({{link}})",
  "The label printing has failed: please enter the retail price for the price list set up for printing ({{priceName}}).": "L'impression d'étiquette a échouée : veuillez renseigner le prix de vente pour la grille tarifaire paramétrée à l'impression ({{priceName}}).",
  "{{quantity}} print of the label has been started.": "{{quantity}} impression de l'étiquette a été lancée.",
  "{{quantity}} prints of the label has been started.": "{{quantity}} impressions de l'étiquette ont été lancées.",
  "Do not display": "Ne pas afficher",
  "Set settings": "Définir paramètres",
  "No print settings set": "Aucun paramètre d'impression renseigné",
  "To print a label from a product page, you must first enter the print settings.": "Pour imprimer une étiquette depuis une page produit, vous devez d'abord renseigner les paramètres d'impression.",
  "Edit settings": "Éditer paramètres",
  "Format: {{format}}": "Format : {{format}}",
  "Print settings": "Paramètres d'impression",
  "Hello, I am interested in unlocking the label printing feature.": "Bonjour, je suis intéressé par l'obtention de la fonctionnalité d'impression d'étiquette.",
  "Get the feature": "Obtenir la fonctionnalité",
  "This new feature lets you print a label directly from a product page with a Star printer.": "Cette nouvelle fonctionnalité vous permet de lancer en impression une étiquette directement depuis une page produit avec une imprimante Star.",
  "Order label holders online.": "Commander les supports d'étiquettes en ligne.",
  "settings_label_printer_page.request_error.invalid_api_key": "La clé API n'est pas reconnue. Vous pouvez essayer d'en générer une nouvelle ou contacter notre support.",
  "settings_label_printer_page.request_error.unexpected_failure": "Un problème d’authentification au service StarPrinter Online est survenu : la clé API n'est plus reconnue ou l'abonnement a expiré. Actualisez la clé API ci-dessous ou vérifiez l'abonnement.",
  "Piece": "Pièce",
  "If required, you can order adhesive label sheets or rolls online.": "Si besoin, vous pouvez commander les planches ou les rouleaux d'étiquettes adhésives en ligne.",
  "Label printing is in progress.": "L'impression des étiquettes est en cours.",
  "Option only available for unit label format.": "Option disponible uniquement pour le format d'étiquette unitaire.",
  "No StarPrinter printers registered in this shop.": "Aucune imprimante StarPrinter enregistrée pour cette boutique.",
  "Display retail price": "Afficher le prix de vente",
  "Invalid product inventory quantity {{trace}}, product is unit and its quantity must be an integer.": "Quantité inventaire invalide {{trace}}, le produit est unitaire et sa quantité doit être un entier.",
  "This feature only works for PDF sheet of labels generation.": "Cette option ne fonctionne que pour la génération de planche PDF d'étiquettes.",
  "Printing is done on a Star mC-Label3 thermal connected printer.": "L'impression se fait sur une imprimante connectée thermique Star mC-Label3.",
  "Find out more about the printer.": "En savoir plus sur l’imprimante.",
  "Format suitable for Star label printers.": "Format adapté aux imprimantes à étiquettes Star.",
  "Display producer": "Afficher le producteur",
  "Display alcohol volume": "Afficher le degré d'alcool",
  "Display designation": "Afficher l'appellation",
  "Anonymous": "Anonyme",
  "Printers": "Imprimantes",
  "Select a printer": "Sélectionner une imprimante",
  "The default printer has been successfully registered.": "L'imprimante par défaut a été enregistrée avec succès.",
  "The printer has been successfully registered.": "L'imprimante a été enregistrée avec succès.",
  "StarPrinter Online API key": "Clé API StarPrinter Online",
  "Enter API key": "Entrer clé API",
  "Edit StarPrinter Online API key": "Modifier la clé API StarPrinter Online",
  "Label printer": "Imprimante d'étiquettes",
  "Configuration": "Configuration",
  "To connect your printer, enter the StarPrinter Online API key.": "Pour connecter votre imprimante, renseigner la clé API StarPrinter Online.",
  "What is an API key?": "Qu'est ce qu'une clé API ?",
  "This is a unique code that you provide to us so that we can access your Star printer's online functions securely.": "Il s'agit d'un code unique que vous nous fournissez afin que nous puissions accéder aux fonctionnalités en ligne de votre imprimante Star de manière sécurisée.",
  "How do I retrieve the StarPrinter Online API key?": "Comment récupérer la clé API StarPrinter Online ?",
  "Consult the tutorial dedicated to Star printer configuration and StarPrinter Online": "Consulter le tutoriel dédié à la configuration de l'imprimante Star et StarPrinter Online",
  "Settings unsaved.": "Paramètres non sauvegardés.",
  "Settings saved on your web browser, a few moments ago.": "Paramètres sauvegardés sur votre navigateur web, il y a quelques instants.",
  "Don't worry! Print settings are automatically saved on the browser from which you configure them.": "Soyez tranquille ! Les paramètres d'impression sont automatiquement sauvegardés sur le navigateur depuis lequel vous les configurez.",
  "Copies": "Copies",
  "The time must be earlier": "L'heure doit être antérieure",
  "View stock activities": "Consulter mouvements de stock",
  "To view inventory movements following a backdated inventory, filter the movement table by the previous date entered.": "Pour consulter les mouvements d'inventaire suite à un inventaire antidaté, veuillez filtrer le tableau des mouvements sur la date antérieure saisie.",
  "The inventory file is ready. Click on \"Launch import\" to import your file.": "Le fichier d'inventaire est prêt. Cliquez sur « Lancer import » pour importer votre fichier.",
  "The inventory file has been successfully imported! Please wait a few minutes before synchronizing your iPads.": "L'inventaire a été importé avec succès ! Veuillez patienter quelques minutes avant de synchroniser vos iPads.",
  "are": "sont",
  "is": "est",
  "Something wrong happened when importing file, please try again.": "Une erreur est apparue lors de l'import du fichier, veuillez réessayer.",
  "Inventory quantity": "Quantité inventaire",
  "Field to be completed.": "Champ à compléter.",
  "By default, inventory is imported at time": "Par défaut, l'inventaire est importé à l'instant",
  "Time": "Heure",
  "Import option": "Option d'import",
  "Import at an earlier datetime": "Importer à une date et heure antérieure",
  "Select a date": "Sélectionner une date",
  "To save typing time, opt for the": "Pour gagner du temps de saisie, optez pour la",
  "automatic order": "commande automatique",
  "Consult the fast navigation help tutorial": "Consulter le tutoriel d'aide à la navigation rapide",
  "{{supplierVariantsCount}} products are to be imported,\nthe order may be too large (maximum {{supplierVariantsCountLimit}} products).\nPlease use the product picker to select manually the products you need.": "{{supplierVariantsCount}} produits sont à importer, la commande risque d'être trop volumineuse (maximum {{supplierVariantsCountLimit}}).\nVeuillez utiliser la sélection manuelle des produits.",
  "Please pick a supplier.": "Veuillez choisir un fournisseur.",
  "Please leave the selection to pick a supplier.": "Veuillez quitter la sélection et choisir un fournisseur.",
  "Add supplier's products": "Ajouter produits fournisseur",
  "Order supplier": "Fournisseur de la commande",
  "New": "Nouveau",
  "This product is not compatible with the selected price list.": "La remise de ce produit est incompatible avec la grille tarifaire sélectionée.",
  "The discount of this product must have a positive amount.": "La remise de ce produit doit posséder une valeur positive.",
  "Imposter": "Usurpateur",
  "supplier orders": "commandes fournisseur",
  "Download errors reporting": "Télécharger rapport erreurs",
  "An issue when attempting downloading the file occurred.": "Une erreur est survenue lors de la tentative de téléchargement du fichier.",
  "Following the launch of the catalog centralization operation, here are the results obtained:": "Suite au lancement de l'opération de centralisation des catalogues, voici les résultats obtenus :",
  "{{productCount}} new products have been successfully centralized.": "{{productCount}} nouveaux produits ont été centralisés avec succès.",
  "1 new product has been successfully centralized.": "1 nouveau produit a été centralisé avec succès.",
  "{{productCount}} errors detected, some products could not be centralized.": "{{productCount}} erreurs détectées, des produits n'ont pas pu être centralisés.",
  "1 error detected, a product could not be centralized.": "1 erreur détectée, un produit n'a pas pu être centralisé.",
  "The products could not be centralized because identical SKUs were detected within the same store. Click on the \"Download errors reporting\" button to retrieve the list of products to correct.": "Les produits n'ont pas pu être centralisés car des SKU identiques ont été détectés dans une même boutique. Cliquez sur le bouton « Télécharger rapport erreurs » pour récupérer la liste des produits à corriger.",
  "no new product has been centralized.": "aucun nouveau produit n'a été centralisé.",
  "To know more about the catalog centralization": "Pour en savoir plus sur la centralisation des catalogues",
  "To find out what corrections need to be made": "Pour en savoir plus sur les corrections à apporter",
  "please visit the help center.": "rendez-vous sur le centre d'aide.",
  "Centralize catalogs": "Centraliser catalogues",
  "Please wait until the operation is complete": "Veuillez patienter jusqu'à la fin de l'opération",
  "Warning: an operation is still in progress.": "Attention : une opération est toujours en cours d'exécution.",
  "Warning: the inventory import operation is still in progress.": "Attention : l'opération d'import inventaire est toujours en cours.",
  "invalid variant id": "identifiant variante invalide",
  "invalid stock quantity": "quantité de stock invalide",
  "to validate it then to import it": "pour le valider puis l'importer",
  "Inventory validating": "Validation de l'inventaire",
  "Inventory file": "Fichier d'inventaire",
  "The inventory file is incorrect and cannot be processed, several data items are incorrect.": "Le fichier d'inventaire est incorrect et ne peut être chargé, plusieurs données sont erronées.",
  "Last modif. on": "Dernière modif. le",
  "{{date}} to {{time}}": "{{date}} à {{time}}",
  "Modification of the price list is only allowed when there is no selected products.": "La modification de la grille tarifaire n'est seulement possible que lorsqu'aucun produit n'est sélectionné.",
  "Select a country": "Sélectionner un pays",
  "Please select a country before": "Veuillez d'abord sélectionner un pays",
  "Kind": "Type",
  "Reason": "Motif",
  "All": "Tous",
  "All{{feminine}}": "Toutes{{feminine}}",
  ":": " :",
  "Sorting": "Tri",
  "Reasons": "Raisons",
  "Kinds": "Types",
  "Select": "Sélectionner",
  "Erase": "Effacer",
  "Load new inventory": "Charger nouvel inventaire",
  "have been": "ont été",
  "has been": "a été",
  "Launch import": "Lancer import",
  "{{stockCount}} {{stocksPlural}} quantity {{haveBeenPlural}} updated in your catalog": "{{stockCount}} {{stocksPlural}} {{haveBeenPlural}} mis à jour dans votre catalogue",
  "File is ready to be imported:": "Le fichier est prêt pour l'import :",
  "{{stockCount}} {{stocksPlural}} quantity to be updated": "{{stockCount}} {{stocksPlural}} à mettre à jour",
  "Imported file:": "Fichier importé :",
  "File to import:": "Fichier à importer :",
  "Drop your file in this area": "Déposer votre fichier dans cet espace",
  "Before upload your files below, make sure ": "Avant de charger vos fichiers ci-dessous, assurez-vous que ",
  "your file is ready to be imported.": "votre fichier est bien prêt à être importé.",
  "Drag and drop or choose a file to upload the inventory.": "Glisser et déposer ou choisir un fichier pour charger l'inventaire.",
  "Pick file": "Choisir fichier",
  "Load inventory": "Charger l'inventaire",
  "Consult the tutorial dedicated to inventory import": "Consulter le tutoriel dédié à l'importation de l'inventaire",
  "Read precautions before importing": "Lire les précautions avant l'importation",
  "Please be aware that the action of importing inventory is irreversible. Before launching the import of the loaded file, make sure you have taken all the necessary precautions:\n\n1. You have verified that you've entered accurate stock quantities in your import file.\n2. You have checked that the inventory date for your file corresponds to the import options defined in the interface.\n3. You have synchronized all of the store's iPads, and then you have not made any further stock movements on the devices until the inventory has been imported.": "Attention, l'action d'importation de l'inventaire est irréversible. Avant de lancer l'importation du fichier chargé, veuillez vous assurer d'avoir pris toute les précautions nécessaires :\n\n1. Vous vous êtes assuré d'avoir saisi des stocks corrects dans votre fichier d'import.\n2. Vous avez vérifié la correspondance entre la date d'inventaire relative à votre fichier et les options d'import définies dans l'interface.\n3. Vous avez synchronisé l'ensemble des iPads du magasin puis vous n'avez plus effectué de mouvements de stock sur les appareils jusqu'à l'importation de l'inventaire.",
  "Step 1 | Validate the inventory file": "Étape 1 | Valider le fichier d'inventaire",
  "Step 2 | Import the inventory file": "Étape 2 | Importer le fichier d'inventaire",
  "Import finished": "Importation terminée",
  "Please select a shop.": "Veuillez choisir une boutique.",
  "Edit order prices": "Éditer prix commande",
  "Legal representative": "Représentant légal",
  "Oops! It seems your session has expired.": "Oups ! Il semble que votre session a expiré.",
  "Oops! It seems the impersonation has failed.": "Oups ! Il semble que votre isurpation d'identité est échoué.",
  "Some changes in the order have not been saved.": "Des modifications apportées à la commande n'ont pas été enregistrées.",
  "Help center": "Centre d'aide",
  "Contact support": "Contacter le support",
  "Please select the tax again.": "Veuillez à nouveau sélectionner la taxe.",
  "Sale by glass": "Vente au verre",
  "Corky": "Bouchonné",
  "Received supplier orders": "Commandes réceptionnées",
  "Search a supplier": "Rechercher un fournisseur",
  "Search an order": "Rechercher une commande",
  "Promotional type": "Type de promotion",
  "Promotional value": "Valeur de la promotion",
  "Variant ID": "ID Variant",
  "promotionsexport": "exportpromotions",
  "Create supplier": "Créer fournisseur",
  "New stock transfer": "Nouveau transfert de stock",
  "Create stock transfer": "Créer transfert de stock",
  "BETA": "BÊTA",
  "Export orders": "Exporter commandes",
  "Export ordered products": "Exporter produits commandés",
  "Exporting requires a single status.": "L'export ne gère qu'un seul statut à la fois.",
  "orders": "commandes",
  "ordered products": "produits commandés",
  "An issue occurred when attempting to download the {{export}} file.": "Échec du téléchargement du fichier {{export}}.",
  "An issue when downloading the file occurred with this navigator.": "Une erreur lors du téléchargement du fichier est survenue sur ce navigateur.",
  "An issue occurred while generating the URL for the {{export}} file.": "Échec de la génération de l'url pour le fichier {{export}}.",
  "Stock activities multishops export is not supported.": "L'export multi-boutiques des mouvements de stock n'est pas supporté.",
  "Please select a shop beforehand with the filter.": "Veuillez d'abord sélectionner une boutique avec le filtre.",
  "Create order": "Créer commande",
  "See supplier": "Voir fournisseur",
  "Edit information": "Éditer informations",
  "Edit contact": "Éditer contact",
  "Edit location": "Éditer adresse",
  "New contact": "Nouveau contact",
  "New location": "Nouvelle adresse",
  "Edit variant": "Éditer variante",
  "Edit product": "Éditer produit",
  "PLU codes": "Codes PLU",
  "inventory": "inventaire",
  "Inventory": "Inventaire",
  "An issue when downloading the CSV occured with this navigator.": "Une erreur lors du téléchargement du CSV est survenue sur ce navigateur.",
  "Download failed": "Échec du téléchargement",
  "the ordered products": "des produits commandés",
  "the supplier orders": "des commandes fournisseurs",
  "the stock activities": "des mouvements de stock",
  "the PLU codes": "des codes PLU",
  "the inventory": "l'inventaire",
  "Products list empty, please select at least one product before continuing": "Liste de produits vide, veuillez ajouter au moins un produit avant de continuer",
  "The label sheet has been created": "La planche d'étiquettes à bien été créée",
  "Reset products": "Réinitialiser les produits",
  "All non-archived catalog products": "Tous les produits du catalogue non archivés",
  "added products": "produits ajoutés",
  "Please select at least one option": "Veuillez sélectionner au moins une option",
  "Label template": "Format d'étiquette",
  "Suggestions": "Suggestions",
  "Unit label (format {{format}})": "Étiquette unitaire (format {{format}})",
  "Sheet of {{number}} labels (format {{format}})": "Planche de {{number}} étiquettes (format {{format}})",
  "All products": "Tous les produits",
  "Please select at least one product.": "Veuillez sélectionner au moins un produit.",
  "Add products to print labels": "Ajouter des produits pour imprimer des étiquettes",
  "Add products to generate a PDF sheet of labels": "Ajouter des produits pour générer une planche PDF d'étiquettes",
  "Add all products": "Ajouter tous les produits",
  "Import csv": "Importer csv",
  "Please select a price list.": "Veuillez sélectionner une grille tarifaire.",
  "Please activate the barcode display.": "Veuillez activer l'affichage du code-barres.",
  "Required field": "Champ requis",
  "Generate labels": "Générer étiquettes",
  "If needed, ": "Si besoin, ",
  "HERMA - 4201 (A4, 21 or 64 labels per sheet).": "HERMA - 4201 (A4, 21 ou 64 étiquettes par planche).",
  "We offer a unique format of removable labels:": "Nous proposons un unique format d'étiquettes amovibles :",
  "The printing is done on an A4 laser printer.": "L'impression se fait sur une imprimante A4 laser.",
  "Sort alphabetically by product category": "Trier par ordre alphabétique des catégories de produits",
  "Sort alphabetically by product name": "Trier par ordre alphabétique des noms de produits",
  "Do not sort": "Ne pas trier",
  "Display internal code": "Afficher le code interne",
  "Display SKU": "Afficher le SKU",
  "Do not display additional product codes": "Ne pas afficher de code produit supplémentaire",
  "Additional product code": "Code produit supplémentaire",
  "Automatically generate missing barcodes": "Générer automatiquement les codes-barres manquants",
  "Select the price list": "Sélectionner la grille tarifaire",
  "Display barcode": "Afficher le code-barres",
  "Sorting labels": "Tri des étiquettes",
  "Options": "Options",
  "Offset of the first printed label": "Décalage de la première étiquettes imprimée",
  "Print setup": "Paramétrage d'impression",
  "Label information": "Information de l'étiquette",
  "Print label": "Imprimer étiquette",
  "Print labels": "Imprimer étiquettes",
  "Print the labels": "Imprimer les étiquettes",
  "Export PLU codes": "Exporter codes PLU",
  "Export filtered inventory": "Exporter inventaire filtré",
  "Export inventory": "Exporter inventaire",
  "Import inventory": "Importer inventaire",
  "There is no more PLU code available.": "Plus aucun code PLU n'est disponible.",
  "This PLU code is used by another product.": "Ce code PLU est utilisé par un autre produit.",
  "The PLU code must be between 1 and 9997.": "Le code PLU doit être compris entre 1 et 9997.",
  "SKU code": "Code SKU",
  "PLU code": "Code PLU",
  "Loading": "Chargement",
  "Generate code": "Générer code",
  "{{amount}} of deductible VAT ({{percent}})": "{{amount}} de TVA déductible ({{percent}})",
  "Once the product is archived, all its variants will be archived too.\nIts variants will only be visible from the catalog by applying the \"Archive\" filter.": "Une fois le produit archivé, toutes ses variantes seront également archivées.\nSes variantes seront uniquement visibles depuis le catalogue en appliquant le filtre \"Archivé\".",
  "Non existing product": "Produit inexistant",
  "Supplier's informations": "Informations fournisseur",
  "Reference": "Référence",
  "Transfer": "Transfert",
  "Transfer of": "Transfert du",
  "transferorder": "bontransfert",
  "Reference{{entilted}}{{code}}": "Référence{{entilted}}{{code}}",
  "Recipient shop": "Boutique destinatrice",
  "Amount of orders received including VAT": "Montant des commandes réceptionnées TTC",
  "Number of unique references": "Nombre de références uniques",
  "Copy ID": "Copier l'ID",
  "New campaign": "Nouvelle campagne",
  "Create campaign": "Créer campagne",
  "To be fully functional, the promotional campaigns require the update of the cash application in version 1.29.16+.": "Afin d'être pleinement fonctionnelles, les campagnes promotionnelles nécessitent la mise à jour de l'application de caisse en version 1.29.16+.",
  "Beware ! Once the draft is saved, you will no longer be able to edit the price list.": "Attention ! Une fois le brouillon enregistré, vous ne pourrez plus modifier la grille tarifaire.",
  "One of the promotional campaign linked shops does not have a retail price entered for that product on the selected price list.": "Une boutique liée à la campagne promotionnelle n'a pas de prix de vente saisi pour ce produit sur la grille tarifaire sélectionnée.",
  "Please add at least one product.": "Veuillez ajouter au moins un produit.",
  "Edit campaign": "Éditer campagne",
  "Please select at least one shop.": "Veuillez sélectionner au moins une boutique.",
  "Please select a price name.": "Veuillez sélectionner une grille tarifaire.",
  "Please select a date range.": "Veuillez sélectionner une période.",
  "Start date": "Date de début",
  "End date": "Date de fin",
  "Active shops": "Boutiques actives",
  "Discounted products": "Produits remisés",
  "Pending approval": "En attente d'approbation",
  "Resume": "Reprendre",
  "Stop": "Stopper",
  "Stopped": "Stoppé",
  "Unschedule": "Déprogrammer",
  "Schedule": "Programmer",
  "Scheduled": "Programmé",
  "Unscheduled": "Déprogrammé",
  "Error": "Erreur",
  "Published": "Publié",
  "Excluded": "Exclu",
  "Expired": "Expiré",
  "Ongoing": "En cours",
  "Pending": "En attente",
  "To Send": "À envoyer",
  "Once the draft is saved, you will no longer be able to edit the selection.": "Une fois le brouillon enregistré, vous ne pourrez plus modifier la sélection.",
  "Please select the price list beforehand.": "Veuillez d'abord sélectionner la grille tarifaire.",
  "Campaign management by shop": "Gestion de la campagne par boutique",
  "Start of the campaign at the": "Début de la campagne le",
  "End of the campaign at the": "Fin de la campagne le",
  "Campaign": "Campagne",
  "Information": "Informations",
  "Beware no prices matching the selected price list \"{{priceName}}\" exist for this product.": "Attention, aucun prix de vente ne correspond avec la grille tarifaire sélectionnée \"{{priceName}}\" pour ce produit.",
  "Select a price list": "Sélectionner une grille tarifaire",
  "No price list": "Aucune grille tarifaire",
  "Name of the campaign": "Nom de la campagne",
  "Dates of the campaign": "Dates de la campagne",
  "Wine fair 2020": "Foire aux vins 2020",
  "Numeric input field": "Champ de saisie numérique",
  "Discounted price": "Prix remisé",
  "Please select the price list first to see the retail price.": "Veuillez d'abord sélectionner la grille tarifaire afin de voir le prix de vente apparaitre.",
  "Product & description": "Produit et description",
  "Promotional campaign": "Campagne promotionnelle",
  "Promotional campaigns": "Campagnes promotionnelles",
  "New promotional campaign": "Nouvelle campagne promotionnelle",
  "Please add products to create your promotional campaign.": "Veuillez ajouter des produits pour créer votre campagne promotionnelle.",
  "Add products to create your promotional campaign": "Ajouter des produits pour créer votre campagne promotionnelle",
  "Wino could not generate the PDF, please reiterate your request.": "Wino n'a pas pu générer le PDF, veuillez réitérer votre requête.",
  "Coeff": "Coeff",
  "Margin rt": "Tx de marque",
  "Markup rt": "Tx de marge",
  "Margin/Markup rt": "Tx de marque/marge",
  "Margin rate": "Taux de marque",
  "Markup rate": "Taux de marge",
  "Title": "Intitulé",
  "Wino could not update the retail prices, please refresh the page before trying again.": "Wino n'a pas pu mettre à jour les prix de ventes, veuillez rafraichir la page et tenter à nouveau.",
  "To be filled": "À renseigner",
  "The capacity unit cannot be changed.": "L'unité de contenance ne peut être modifiée.",
  "Once the product has been created in bulk, the capacity unit can't be modified.": "Une fois le produit créé en vrac, l'unité de contenance ne sera plus modifiable.",
  "You cannot duplicate the product variant only. It is necessary to duplicate the whole product. [Duplicate product]({{link}})": "Vous ne pouvez pas dupliquer la variante du produit uniquement. Il est nécessaire de dupliquer le produit complet. [Dupliquer le produit]({{link}})",
  "An unexpected error occured. Please try again or contact the support.": "Une erreur inattendue est survenue. Veuillez retenter ou contacter le support.",
  "Period": "Période",
  "Today": "Aujourd'hui",
  "Yesterday": "Hier",
  "Last week": "Semaine dernière",
  "Current week": "Semaine en cours",
  "Current month": "Mois en cours",
  "Last month": "Mois dernier",
  "Current year": "Année en cours",
  "Last year": "Année dernière",
  "Current fiscal year": "Année fiscale en cours",
  "Last fiscal year": "Année fiscale dernière",
  "Something went wrong": "Quelque chose s'est mal passée.",
  "Something went wrong during the automatic order taking proccess.": "Une erreur est apparue lors de la prise de commande automatique.",
  "No products matching the set stock thresholds were found for the supplier {{supplier}}.": "Aucun produit correspondant aux seuils de stock paramétrés n'a été trouvé pour le fournisseur {{supplier}}.",
  "1 product has been correctly added to the cart.": "1 produit a été ajouté à la commande avec succès.",
  "{{quantity}} products have been correctly added to the cart.": "{{quantity}} produits ont été ajoutés à la commande avec succès.",
  "Search for {{supplier}} products in progress...": "Recherche de produits {{supplier}} en cours...",
  "Analyzing products and their stock": "Analyse des produits et leurs stock",
  "Order taking": "Préparer la commande",
  "Do you want your order for {{supplier}} to be automatically prepared according to the stock threshold settings of the products ?": "Souhaitez-vous que votre commande pour {{supplier}} soit automatiquement préparées d'après les paramètres de seuil de stock des produits ?",
  "Confirm to add the products otherwise click Cancel. You will still be able to modify the order once the products have been added.": "Confirmez pour ajouter les produits sinon cliquez sur Annuler. Vous pourrez toujours modifier la commande une fois les produits ajoutés.",
  "Please filter the product page on a single shop to edit its internal memo.": "Veuillez filtrer la fiche produit sur un catalogue afin de pouvoir éditer sa note.",
  "Beer style": "Style de bière",
  "In case the category is let undefined, the product won't appear in the Cash register module of the Wino Ipad app.": "Si la catégorie n'est pas définie, le produit n'apparaîtra pas dans le module Caisse de l'application Wino sur iPad.",
  "This value must be positive": "Cette valeur doit être positive",
  "edit": "éditer",
  "create": "créer",
  "Create reference": "Créer référence",
  "Please select the shop with which you would like to generate labels.": "Veuillez d'abord sélectionner la boutique avec laquelle vous souhaitez générer des étiquettes.",
  "Please select the shop in which you would like to {{action}} the reference.": "Veuillez d'abord sélectionner la boutique dans laquelle vous souhaitez {{action}} la référence.",
  "Complete the product information.\nThe information of this reference will be later enriched by the information of the variant.": "Compléter les informations générales du produit.\nLes informations de cette référence seront par la suite enrichies par les informations de la fiche variante.",
  "Enter in which categorie this product should belong to.": "Indiquer à quelle catégorie appartient ce produit.",
  "Please pick or create a designation": "Veuillez sélectionner ou créer la désignation",
  "Please pick or create a region": "Veuillez sélectionner ou créer la région",
  "Please pick or create a family": "Veuillez sélectionner ou créer la famille",
  "Please pick or create a beer style": "Veuillez sélectionner ou créer le style de bière",
  "The reference has been correctly created.": "La référence a bien été créée.",
  "Continue": "Continuer",
  "Step {{step}} | Create {{fulfill}}": "Étape {{step}} | Créer {{fulfill}}",
  "wine": "vin",
  "spirituous": "spiritueux",
  "beer": "bière",
  "simple product": "produit classique",
  "New reference": "Nouvelle référence",
  "The variant has been correctly created.": "La variante a bien été créée.",
  "Please define a purchase price beforehand": "Veuillez définir un prix d'achat au préalable",
  "Enter the retail prices for each of your price lists.": "Saisir les prix de vente pour vos différentes grilles tarifaires.",
  "Initial stock": "Stock initial",
  "Indicate the initial stock quantity of the reference or leave the stock at zero and create an order for the reception of the product.": "Indiquer la quantité en stock initiale de la référence ou laisser le stock à zéro et créer une commmande pour la réception du produit.",
  "Bulk by kg": "Vrac au kg",
  "Bulk by {{unit}}": "Vrac au {{unit}}",
  "Enter the product purchase price.": "Saisir le prix d'achat du produit.",
  "Accounting account": "Compte comptable",
  "Bulk product management": "Produit en gestion au vrac",
  "New variant": "Nouvelle variante",
  "years": "ans",
  "year": "an",
  "months": "mois",
  "month": "mois",
  "Capacity": "Contenance",
  "Capacity unit": "Unité de contenance",
  "Vintage": "Millésime",
  "Variant's name": "Nom de la variante",
  "Alcohol volume": "Degré d'alcool",
  "Barcode": "Code-barres",
  "Please enter a capacity value.": "Veuillez saisir la contenance.",
  "Please enter a unit.": "Veuillez saisir une unité.",
  "Please pick a color.": "Veuillez choisir une couleur.",
  "Please pick a wine type.": "Veuillez choisir un type de vin.",
  "Please pick the white wine type.": "Veuillez choisir le type de vin blanc.",
  "Dry": "Sec",
  "Semi dry": "Demi-sec",
  "Soft": "Moelleux",
  "Sweet": "Liquoreux",
  "Editing": "Édition",
  "Beer type": "Type de bière",
  "Add a producer": "Ajouter un producteur",
  "Add a designation": "Ajouter une appellation",
  "Add a family": "Ajouter une famille",
  "Add a beer style": "Ajouter un style de bière",
  "Add a region": "Ajouter une région",
  "Add a country": "Ajouter un pays",
  "Add a wine type": "Ajouter un type de vin",
  "Add a beer type": "Ajouter un type de bière",
  "Select an unit": "Sélectionner une unité",
  "Select a tax value": "Sélectionner un taux de TVA",
  "Unable to load VAT rates, your session may have expired. Please reload the page.": "Impossible de charger les taux de TVA, votre session a peut-être expiré. Veuillez recharger la page.",
  "Select a color": "Sélectionner une couleur",
  "Select a wine type": "Sélectionner un type de vin",
  "Select a white wine type": "Sélectionner un type de vin blanc",
  "Producer": "Producteur",
  "Family": "Famille",
  "Designation": "Appellation",
  "Region": "Région",
  "Color": "Couleur",
  "Wine type": "Type de vin",
  "White wine type": "Type de vin blanc",
  "Still": "Tranquille",
  "White": "Blanc",
  "Red": "Rouge",
  "Rose": "Rosé",
  "Amber": "Ambré",
  "Dark": "Brun",
  "Black": "Noir",
  "The variant information have been correctly updated.": "Les informations de la variante ont bien été mises à jour.",
  "The product information have been correctly updated.": "Les informations du produit ont bien été mises à jour.",
  "By entering a capacity value and a year, the variant name will be automatically generated.": "En saisissant la contenance et/ou le millésime, le nom de variante sera automatiquement généré.",
  "To save typing time, opt for automatic ordering !": "Pour gagner du temps de saisie, optez pour la commande automatique !",
  "Please select a supplier linked to the order.": "Veuillez sélectionner un fournisseur lié à la commande.",
  "Create automatic order": "Créer commande automatique",
  "Please select the shop catalog from which the CSV products will be imported.": "Veuillez d'abord sélectionner le catalogue boutique auquel les produits du CSV seront importés.",
  "The product \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to your shop.": "Le produit \"{{referenceName}}\" du catalogue {{shopName}} a bien été ajouté au catalogue de la boutique.",
  "The product \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to the selected shops.": "Le produit \"{{referenceName}}\" du catalogue {{shopName}} a bien été ajouté au catalogue des boutiques sélectionnés.",
  "The variant \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to your shop.": "La variante \"{{referenceName}}\" du catalogue {{shopName}} a bien été ajoutée au catalogue de la boutique.",
  "The variant \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to the selected shops.": "La variante \"{{referenceName}}\" du catalogue {{shopName}} a bien été ajoutée au catalogue des boutiques sélectionnés.",
  "Add a category": "Ajouter une catégorie",
  "The product of the target catalog cannot be duplicated as its reference already exists inside the catalogs of all your shops.": "Vous ne pouvez pas dupliquer le produit car la référence existe déjà dans les catalogues de toutes vos boutiques.",
  "The variant of the target catalog cannot be duplicated because no reference matches the duplication criteria.": "Vous ne pouvez pas dupliquer la variante du produit car aucune référence ne correspond aux critères de duplication.",
  "Please select a catalog to duplicate.": "Veuillez sélectionner un catalogue à dupliquer",
  "Please select at least one target shop to duplicate to.": "Veuillez sélectionner au moins un catalogue cible recevant la copie.",
  "Reference already existing": "Référence déjà existante",
  "Reference not duplicable, missing product": "Référence non duplicable, produit lié manquant",
  "Please select the shop catalog to duplicate from in order to select the targeted catalogs.": "Veuillez d'abord sélectionner le catalogue boutique à dupliquer pour sélectionner les catalogues cibles.",
  "Additional information": "Informations complémentaires",
  "Shop catalog": "Catalogue boutique",
  "Shop catalog to duplicate": "Catalogue boutique à dupliquer",
  "Shop catalogs targeted": "Catalogues boutiques visés",
  "Select the shop catalog from which the product and its variants will be duplicated.": "Sélectionnez le catalogue boutique à partir duquel le produit et ses variantes seront dupliqués.",
  "Select the shop catalog from which the variant will be duplicated.": "Sélectionnez le catalogue boutique à partir duquel la variante sera dupliquée.",
  "Select the shop catalogs to where the product and its variants will be duplicated then add the missing categories.": "Sélectionnez les catalogues boutiques dans lesquels le produit et ses variantes seront dupliqués et ajoutez les catégories manquantes.",
  "Select the shop catalogs to where the variant will be duplicated.": "Sélectionnez les catalogues boutiques dans lesquels la variante sera dupliquée.",
  "Duplicate the variant": "Dupliquer la variante",
  "Duplicate the product and its variants": "Dupliquer le produit et ses variantes",
  "Please first select the shop below in order to pick a supplier.": "Veuillez d'abord sélectionner votre boutique en dessous afin de pouvoir choisir un fournisseur.",
  "Something wrong happened, please try again or contact the support through the bottom left side corner chat button.": "Une erreur est survenue, veuillez essayer à nouveau ou contactez le support à travers le bouton de discussion en bas à gauche.",
  "Couldn't update the tasting note.": "La note de dégustation n'a pas pu être mise à jour.",
  "Couldn't update the internal note.": "La note interne n'a pas pu être mise à jour.",
  "The purchase price shouldn't exceed the entered retail prices.": "Le prix d'achat ne devrait pas être supérieur aux prix de vente saisis.",
  "Undefined": "Non défini",
  "Search results": "Résultats de recherche",
  "Results": "Résultats",
  "Other suggestions": "Autres propositions",
  "Loading error": "Erreur de chargement",
  "The product stocks couldn't be updated on this order.\nWino is aware of this technical issue and is working to resolve it in a future version of app.wino.fr.": "Nous ne pouvons pas afficher vos stocks produit à jour sur la commande.\nLa résolution de ce problème technique est prévue pour une prochaine version de app.wino.fr.",
  "Differing": "Variable",
  "Missing shop": "Boutique manquante",
  "Shop": "Boutique",
  "Filter the product page on a single shop to visualize and update its tasting note or internal memo.": "Filtrer la fiche produit sur une unique boutique pour visualiser et mettre à jour sa note de dégustation ou sa note interne.",
  "Beware, some information differs among the catalogs of the shops.": "Attention, certaines informations divergent entre les catalogues des boutiques.",
  "Show more": "Voir plus",
  "Collapse": "Réduire",
  "From catalog of": "Pour le catalogue de",
  "Statuses": "Statuts",
  "VAT not specified": "TVA non renseignée",
  "Not classified": "Non classé",
  "Price list": "Grille tarifaire",
  "Mr": "M.",
  "Mrs": "Mme",
  "See bound product": "Voir produit lié",
  "Close": "Fermer",
  "Finished": "Terminé",
  "The order has successfully been sent to Kviste. [Get to cart]({{link}})": "La commande a bien été envoyée sur Kviste. [Voir le panier]({{link}})",
  "The order could not be sent to Kviste.": "La commande n'a pas pu être envoyée sur Kviste.",
  "Purchase price": "Prix d'achat",
  "Purchasing price": "Prix à l'achat",
  "Recipient": "Destinataire",
  "Phone": "Téléphone",
  "Shop phone": "Téléphone de la boutique",
  "Employment": "Fonction",
  "mikehasford@company.com": "jeandubois@entreprise.fr",
  "contact@company.com": "contact@entreprise.fr",
  "Invoicing": "Facturation",
  "Billing": "Facturation",
  "Loss reason": "Motif de perte",
  "This number must range between {{min}} and {{max}} inclusive.": "Ce nombre doit être compris entre {{min}} et {{max}} inclu",
  "This number must be superior to {{min}}": "Ce nombre doit être supérieur à {{min}}",
  "This number must be inferior to {{max}}": "Ce nombre doit être inférieur à {{max}}",
  "Report a loss": "Déclarer une perte",
  "Report a delivery": "Déclarer une livraison",
  "unit(s)": "unité(s)",
  "No order has been yet recorded": "Aucune commande n'a été enregistrée",
  "No stock activity has been yet recorded": "Aucun mouvement de stock n'a été enregistré",
  "No received order has been yet recorded": "Aucune commande réceptionnée n'a été enregistrée",
  "No product variant has been yet recorded": "Aucune variante du produit n'a été enregistrée",
  "Location": "Adresse",
  "Cancel": "Annuler",
  "Discard": "Annuler",
  "Save": "Enregistrer",
  "save": "enregistrer",
  "Previous": "Précédent",
  "Next": "Suivant",
  "Validate": "Valider",
  "Back": "Retour",
  "Edit the category": "Éditer la catégorie",
  "Edit": "Modifier",
  "First name": "Prénom",
  "Last name": "Nom",
  "Billing address": "Adresse de facturation",
  "Address": "Adresse",
  "ADDRESSES": "ADRESSES",
  "Phone number": "Numéro de téléphone",
  "EURO": "€",
  "USD": "$",
  "POUND": "£",
  "New supplier": "Nouveau fournisseur",
  "Paid": "Payé",
  "To pay": "À payer",
  "Unpaid": "Impayé",
  "Draft": "Brouillon",
  "Credited balance": "Soldé par avoir",
  "Accepted": "Accepté",
  "Finalized": "Finalisé",
  "Start reception": "Démarrer réception",
  "Not received": "Non réceptionné",
  "Issue date": "Date d'ém.",
  "Reception date": "Date de réc.",
  "Due date": "Date d'éch.",
  "Reception in progress": "Réception en cours",
  "Reception finished": "Réception terminée",
  "New order": "Nouvelle commande",
  "Product": "Produit",
  "product": "produit",
  "Product's name": "Nom du produit",
  "Stock": "Stock",
  "Stock exp.": "Stock exp.",
  "Stock dest.": "Stock dest.",
  "Ord. qt": "Qté com.",
  "Rec. qt": "Qté reçue",
  "U. price": "Prix u.",
  "U. price excl. VAT": "Prix u. HT",
  "U. price incl. VAT": "Prix u. TTC",
  "U. cost": "Coût u. HT",
  "U. fees": "Frais u. HT",
  "U. discounts": "Remise HT",
  "Discount": "Remise",
  "Total excl. VAT": "Total HT",
  "Qty": "Qté",
  "Product and description": "Produit et description",
  "U. price excl.": "Prix u. HT",
  "U. price incl.": "Prix u. TTC",
  "Total excl.": "Total HT",
  "Total VAT": "Total TVA",
  "Total incl.": "Total TTC",
  "Unknown product": "Produit inconnu",
  "VAT": "TVA",
  "VAT excl. base": "Base HT",
  "excl. tax": "HT",
  "incl. tax": "TTC",
  "Amount VAT incl.": "Montant TTC",
  "Amount VAT excl.": "Montant HT",
  "Add costs": "Ajouter frais",
  "Add discount": "Ajouter remise",
  "Remove line": "Supprimer ligne",
  "Finalize": "Finaliser",
  "finalize": "finaliser",
  "Remove cost": "Supprimer frais",
  "Total amount incl. VAT": "Montant total TTC",
  "Total amount excl. VAT": "Montant total HT",
  "Total amount": "Montant total",
  "VAT incl. after discount": "TTC après remise",
  "Select a price list and add product": "Sélectionner une grille tarifaire et ajouter produit",
  "Product append": "Ajout de produits",
  "Search product": "Rechercher un produit",
  "Create product": "Créer produit",
  "Import supplier products": "Importer produits fournisseur",
  "Supplier information": "Informations fournisseur",
  "Orders information": "Informations de commande",
  "Select a supplier": "Sélectionner un fournisseur",
  "Select a customer": "Sélectionner un client",
  "Select a producer": "Sélectionner un producteur",
  "Select a category": "Sélectionner une catégorie",
  "Contact": "Contact",
  "Contacts": "Contacts",
  "Issuing date": "Date d'émission",
  "Global merchandise discount": "Remise globale marchandises",
  "Reception scheduled on": "Réception estimée le",
  "Reception completed on": "Réception terminée le",
  "Issued on": "Émise le",
  "By": "Par",
  "Conditions": "Conditions",
  "Supplier note": "Note au fournisseur",
  "Estimated date of reception": "Date de réception estimée",
  "Free": "Offert",
  "Quantity concerned": "Quantité concernée",
  "Quantity offered": "Quantité offerte",
  "Discount type": "Type de remise",
  "Cost type": "Type de frais",
  "Unit amount": "Montant unitaire",
  "Discount {{amount}}": "Remise {{amount}}",
  "Offered product": "Produit offert",
  "1 offered product": "1 produit offert",
  "Immediate discount on the next cart": "Réduction immédiate sur le prochain panier",
  "Voucher of {{amount}}": "Bon d'achat de {{amount}}",
  "Voucher of {{amount}} / {{points}}": "Bon d'achat de {{amount}} / {{points}}",
  "{{percent}} discount": "{{percent}} de remise",
  "Discount amount": "Montant de la remise",
  "Discount percentage": "Pourcentage de la remise",
  "Discount application": "Application de la remise",
  "Remove discount": "Supprimer remise",
  "Hide options": "Masquer options",
  "Show options": "Afficher options",
  "Show only supplier related products": "Afficher uniquement les produits liés au fournisseur",
  "No products available corresponding to your search": "Pas de produits disponibles correspondant à votre recherche",
  "Edit contact information": "Modifier les informations de contact",
  "Save the changes in the Supplier directory": "Enregistrer les modifications dans le répertoire Fournisseur",
  "Apply to all products and close": "Appliquer à tous les produits et fermer",
  "For the company": "Pour l'entreprise",
  "Name of the responsible": "Nom du responsable",
  "Transport": "Transport",
  "Taxes": "Taxes",
  "Other": "Autre",
  "Others": "Autres",
  "Notes": "Notes",
  "%": "%",
  "Good to see you again !": "Bon retour parmi nous !",
  "Email": "E-mail",
  "Email address": "Adresse e-mail",
  "Account email": "E-mail du compte",
  "Password": "Mot de passe",
  "Invalid password.": "Mot de passe invalide.",
  "Invalid email address.": "Adresse e-mail invalide.",
  "Show": "Montrer",
  "Hide": "Masquer",
  "Forgot password ?": "Mot de passe oublié ?",
  "Sign in": "Se connecter",
  "Sign in ...": "Connexion ...",
  "Keep signed in": "Rester connecté",
  "name@yourcompany.com": "nom@entreprise.com",
  "Incorrect credentials.": "Les identifiants entrés sont introuvables.",
  "Recover your password": "Réinitialiser votre mot de passe",
  "Reset password": "Réinitialiser le mot de passe",
  "Password resetting": "Réinitialiser votre mot de passe",
  "Your password has been correctly modified": "Votre mot de passe a bien été modifié",
  "Type the email address associated with your account, and we will send you a link to reset your password. If you don’t receive the email, please check your spam folder. If no email arrives, it means there is no account associated with that address.": "Entrez l'adresse e-mail associée à votre compte, et nous vous enverrons un lien pour réinitialiser votre mot de passe. Si vous ne recevez pas l'e-mail, veuillez vérifier dans votre dossier de spams. Si aucun e-mail n'arrive, cela signifie qu'aucun compte n'est associé à cette adresse.",
  "Send a recovery link": "Envoyer un lien de réinitialisation par e-mail",
  "You should have received the recovery link by the next minutes.": "Vous allez recevoir le lien par e-mail d'ici quelques minutes.",
  "New password confirmation": "Confirmation du nouveau mot de passe",
  "New password": "Nouveau mot de passe",
  "At least 10 characters": "10 caractères au minimum",
  "Incorrect password": "Mot de passe incorrect",
  "One lowercase letter": "Une minuscule",
  "One uppercase letter": "Une majuscule",
  "One digit": "Un chiffre",
  "One special character": "Un caractère spécial",
  "Password and its confirmation must be identical": "Les mots de passe entrés ne sont pas identiques",
  "Home": "Accueil",
  "Login": "Authentification",
  "Supplier": "Fournisseur",
  "Suppliers": "Fournisseurs",
  "Supplier orders": "Commandes fournisseur",
  "Order": "Commande",
  "Orders": "Commandes",
  "Invoice": "Facture",
  "Invoices": "Factures",
  "Invoice & credit": "Facture & avoir",
  "Invoices & credits": "Factures & avoirs",
  "Contact us": "Contactez-nous",
  "Profile": "Profil",
  "Preferences": "Préférences",
  "Sign out": "Se déconnecter",
  "Cashing": "Encaissement",
  "Quotes": "Devis",
  "Quote": "Devis",
  "Delivery order": "Bon de livraison",
  "Receipts": "Tickets de caisse",
  "Receipt": "Ticket de caisse",
  "Receipts journal": "Journaux de caisse",
  "Activity reports": "Rapports d'activité",
  "Sales": "Ventes",
  "sales": "ventes",
  "Products": "Produits",
  "Admin": "Admin",
  "Add filter": "Ajouter filtre",
  " of ": " sur ",
  "Every shops": "Toutes les boutiques",
  "Create {{name}}": "Créer {{name}}",
  "Search {{name}}": "Rechercher {{name}}",
  "Loading...": "Chargement…",
  "Please wait.": "Veuillez patienter.",
  "No result found": "Aucun résultat",
  "No result were found.": "Aucun résultat trouvé.",
  "Welcome to the {{name}} space.": "Bienvenue sur l'espace de {{name}}.",
  "Try again with another keyword or filter.": "Tentez votre recherche avec un autre mot-clé ou filtre.",
  "Try again with another keyword or:": "Tentez votre recherche avec un autre mot-clé ou :",
  "Try again with another keyword/filter or:": "Tentez votre recherche avec un autre mot-clé/filtre ou :",
  "Start creating your first {{name}}.": "Créez ici votre première {{name}}.",
  "Loading issue": "Problème de chargement",
  "Please try refreshing the page.": "Veuillez tenter de recharger la page.",
  "Reload the page": "Recharger la page",
  "Refresh": "Recharger",
  "CONTACT": "CONTACT",
  "Yes": "Oui",
  "No": "No",
  "Name": "Nom",
  "Loyalty": "Fidélité",
  "Not a member yet": "Pas encore membre",
  "Unsubscribed on {{date}}": "Désinscrit le {{date}}",
  "Eligible reward": "Récompense éligible",
  "Eligible rewards": "Récompenses éligibles",
  "Confirm the unsubscription from the loyalty program": "Confirmer la désinscription du programme de fidélité",
  "Unsubscribe": "Désinscrire",
  "Not yet subscribed!": "Pas encore inscrit !",
  "This customer is not a member of the loyalty program": "Ce client n’est pas membre du programme de fidélité",
  "Subscribe the customer to loyalty": "Inscrire client à la fidélité",
  "Subscribe the customer to the loyalty program": "Inscrire le client au programme de fidélité",
  "Unsubscribe the customer": "Désinscrire le client",
  "Change the number of points": "Changer le nombre de points",
  "Once unsubscribed, the customer will no longer earn points nor benefit from rewards.": "Une fois désinscrit, le client ne cumulera plus de points et ne bénéficiera plus des récompenses.",
  "Edit loyalty points": "Modifier les points de fidélité",
  "New points total": "Nouveau total de points",
  "Evolutive": "Évolutif",
  "From {{points}}": "À partir de {{points}}",
  "{{visits}} checkout visit": "{{visits}} visite en caisse",
  "{{visits}} checkout visits": "{{visits}} visites en caisse",
  "Points reset on use": "Réinitialisation des points à l’utilisation",
  "Documents": "Documents",
  "1 reward": "1 récompense",
  "{{count}} rewards": "{{count}} récompenses",
  "Number": "Numéro",
  "Company name": "Nom de l'entreprise",
  "Customer": "Client",
  "Customers": "Clients",
  "customers": "clients",
  "Try your search with another keyword": "Tentez votre recherche avec un autre mot-clé",
  "Add products to complete your supplier order.": "Ajouter des produits pour compléter votre commande fournisseur.",
  "Name & description": "Nom & description",
  "Category": "Catégorie",
  "Status": "Statut",
  "Active": "Actif",
  "Inactive": "Inactif",
  "On sale": "En vente",
  "Unlisted": "Retiré",
  "Search a stock transfer": "Rechercher un transfert de stock",
  "Search a product": "Rechercher un produit",
  "Archived": "Archivé",
  "Not archived": "Non archivé",
  "Export": "Exporter",
  "More": "Plus",
  "See more": "Voir plus",
  "More actions...": "Plus d'actions...",
  "Duplicate": "Dupliquer",
  "Delete": "Supprimer",
  "Open PDF": "Ouvrir PDF",
  "Open PDF (order)": "Ouvrir PDF (commande)",
  "Open PDF (reception)": "Ouvrir PDF (réception)",
  "Send": "Envoyer",
  "Sent": "Envoyé",
  "Declined": "Décliné",
  "Archive": "Archiver",
  "Define as declined": "Définir comme refusé",
  "Define as accepted": "Définir comme accepté",
  "Finish reception": "Terminer réception",
  "Define as billed": "Définir comme facturé",
  "Define as paid": "Définir comme payé",
  "Change to declined": "Changer en refusé",
  "Change to accepted": "Changer en accepté",
  "The discount is applied to the unit price of the product": "La remise est appliquée sur le prix unitaire du produit",
  "Search": "Rechercher",
  "Add products": "Ajouter les produits",
  "selected products": "produits sélectionnés",
  "selected product": "produit sélectionné",
  "Filter": "Filtrer",
  "Send to kviste": "Envoyer sur kviste",
  "Import kviste": "Import csv",
  "Border taxes": "Taxes douanière",
  "Invalid reference": "Référence incorrecte",
  "Invalid column": "Colonne incorrecte",
  "Invalid quantity": "Quantité incorrecte",
  "{{msg}} at column {{col}} row {{row}}.": "{{msg}} à la colonne {{col}} ligne {{row}}.",
  "invalid reference (SKU)": "référence incorrecte (SKU)",
  "invalid column": "colonne incorrecte",
  "invalid quantity": "quantité incorrecte",
  "{{msg}} at column {{col}} row {{row}}": "{{msg}} à la colonne {{col}} ligne {{row}}",
  "The number of data entries from the imported CSV doesn't match with the current order product number.": "Le nombre d'entrées lors de l'import du CSV ne correspond pas au nombre de produits de la commande actuelle.",
  "Unavailable": "Indisponible",
  "Import your file": "Importer votre fichier",
  "Import your {{types}} file by drag and dropping it in here.": "Importer votre fichier {{types}} en le déposant dans cet espace.",
  "Ordered quantity must be greater than 0.": "La quantité commandée doit être supérieure à 0.",
  "Packaging by {{packaging}}": "Quantité par {{packaging}}",
  "{{x}} errors have been identified. Please correct the order to {{action}}.": "{{x}} erreurs ont été identifiées. Corriger la commande pour {{action}}.",
  "1 error has been identified. Please correct the order to {{action}}.": "1 erreur a été identifiée. Corriger la commande pour {{action}}.",
  "The order should have at least one product in cart.": "La commande doit contenir au moins un produit.",
  "Edit order": "Éditer commande",
  "Already added": "Déjà ajouté",
  "Catalog": "Catalogue",
  "Goods total excl. VAT": "Total Marchandises HT",
  "Total {{feeKind}}": "Total {{feeKind}} HT",
  "VAT {{amount}}": "TVA {{amount}} %",
  "Total discount : {{amount}}": "Total remise : {{amount}}",
  "Subtotal excl. VAT": "Sous-total HT",
  "Subtotal incl. VAT": "Sous-total TTC",
  "Order{{entilted}}{{name}}": "{{entilted}} Commande {{name}}",
  "Internal memo": "Note interne",
  "Internal code": "Code interne",
  "Edition": "Édition",
  "Continue reception": "Continuer réception",
  "Ooops ! Looks like something went wrong here.": "Ooops ! Un problème semble s'être produit par ici.",
  "Ooops ! This page doesn't seem available now.": "Ooops ! Cette page ne semble pas disponible actuellement.",
  "Go back to the previous page": "Retourner à la page précédente.",
  "Go back to the home page": "Retourner à la page d'accueil.",
  "Apply to all products": "Appliquer à tous les produits",
  "Remove this fee": "Supprimer ce frais",
  "Remove": "Supprimer",
  "Create draft": "Créer brouillon",
  "Missing supplier": "Fournisseur manquant",
  "There are some errors in the form, please correct them before trying to send it again.": "Des erreurs ont été identifiées dans le formulaire, veuillez les corriger avant de retenter un envoi.",
  "Kviste service is temporarily unavailable.": "Le service Kviste est momentanément indisponible",
  "No registration": "Aucun enregistrement",
  "No variant association to this shop has been recorded.": "La variante n'est pas enregistrée dans le catalogue de la boutique.",
  "No product association to this shop has been recorded.": "Le produit n'est pas enregistré dans le catalogue de la boutique.",
  "Errors details": "Détails des erreurs",
  "Details": "Détails",
  "See errors detail": "Voir le détail des erreurs",
  "See detail": "Voir le détail",
  "Research...": "Rechercher...",
  "Cannot be greater than {{max}}": "Ne peut être supérieure à {{max}}",
  "All shops": "Toutes les boutiques",
  "All products from the imported CSV have been successfully added to the cart!": "Tous les produits du fichier importé ont été ajoutés au panier avec succès !",
  "{{count}} products from the imported CSV have been successfully added to the cart!": "{{count}} produits du fichier importé ont été ajoutés au panier avec succès !",
  "{{count}} products from the imported CSV have not been added to the order": "{{count}} produits du fichier importé n'ont pas pu être ajoutés à la commande",
  "{{count}} product from the imported CSV have not been added to the order": "{{count}} produit du fichier importé n'a pas pu être ajouté à la commande",
  "{{count}} products loaded out of {{total}}": "{{count}} produits chargés sur {{total}}",
  "Address not specified": "Adresse non renseignée",
  "Empty condition": "Pas de condition",
  "Empty note": "Pas de note",
  "Issuing shop": "Boutique émettrice",
  "Product's variants": "Variantes du produit",
  "U. latest price": "Dernier prix u.",
  "Retail price": "Prix de vente",
  "Cost price": "Prix de revient",
  "From ": "Originaire de ",
  "Default VAT of ": "TVA par défaut de ",
  "Inside category ": "Dans la catégorie ",
  "VAT incl.": "TTC",
  "VAT excl.": "HT",
  "VAT exemption": "Éxonération de la TVA",
  "Create variant": "Créer variante",
  "Create a new variant": "Créer une nouvelle variante",
  "Tasting note": "Note de dégustation",
  "Product's information": "Informations produit",
  "Variant's information": "Informations variante",
  "Bound product": "Produit lié",
  "Capacity of": "Contenance de",
  "Alcohol volume of": "Degré d'alcool de",
  "Bar code": "Code barre",
  "Remove from sale": "Retirer de la vente",
  "Mark as on sale": "Remettre en vente",
  "All product variants are archived.": "Toutes les variantes du produit sont archivées.",
  "Shop/Warehouse": "Boutique/Entrepôt",
  "Retail prices": "Prix de vente",
  "Qt": "Qté",
  "Soon available": "Prochainement disponible",
  "{{sku}} could not be found in the current catalog (SKU)": "{{sku}} ne semble pas exister dans le catalogue actuel (SKU)",
  "Download CSV (order)": "Télécharger CSV (commande)",
  "Download CSV (reception)": "Télécharger CSV (réception)",
  "Download CSV": "Télécharger CSV",
  "Download Excel": "Télécharger Excel",
  "Monthly summary": "Synthèse du mois",
  "Daily detail": "Détail par jour",
  "Download PDF": "Télécharger PDF",
  "Download {{orderName}} PDF": "Télécharger PDF de la commande {{orderName}}",
  "purchaseorder": "bondecommande",
  "receiptorder": "bondereception",
  "Purchase order": "Bon de commande",
  "Order receipt": "Bon de réception",
  "Packaging": "Conditionnement",
  "Ordered quantity": "Quantité commandée",
  "Received quantity": "Quantité reçue",
  "Excl. VAT total": "Total HT",
  "VAT total": "Total TVA",
  "Transport U. fees": "Transport Frais u. HT",
  "Taxes U. fees": "Taxes Frais u. HT",
  "Other U. fees": "Autre Frais u. HT",
  "All statuses": "Tous les statuts",
  "Stock activity": "Mouvement de stock",
  "Stock activities": "Mouvements de stock",
  "stock activities": "mouvements de stock",
  "Product name and description": "Nom du produit et description",
  "Activity kind": "Type de mouvement",
  "Datetime": "Date et heure",
  "at": "à",
  "Quantity": "Quantité",
  "Sale": "Vente",
  "Refund": "Remboursement",
  "Delivery": "Livraison",
  "Delivery receipt": "Bon de livraison",
  "Reset": "Réinitialiser",
  "Reseting": "Réinitialisation",
  "Reception": "Réception",
  "Credit note": "Avoir",
  "Contact details": "Coordonnées",
  "General information": "Informations générales",
  "ADDRESS": "ADRESSE",
  "VAT n.": "TVA n°",
  "View all": "Afficher tous",
  "Show all": "Tout afficher",
  "Show all data": "Afficher toutes les données",
  "Orders history": "Historique des commandes",
  "Company information": "Informations de l'entreprise",
  "Total incl. VAT": "Total TTC",
  "Complete the essential information of your new supplier.": "Complétez les informations nécessaires de votre nouveau fournisseur.",
  "Company address": "Adresse de l'entreprise",
  "Company contact": "Contact de l'entreprise",
  "Indicate the supplier's address. It will appear on commercial documents.": "Indiquer l'adresse du fournisseur. Elle apparaîtra sur les documents commerciaux.",
  "Specify the coordinates of your point of contact within the company to communicate effectively.": "Précisez les coordonnées de votre point de contact au sein de l'entreprise pour communiquer efficacement.",
  "Note": "Note",
  "Siret": "Siret",
  "Add a note.": "Ajouter une note.",
  "Home phone": "Téléphone fixe",
  "Mobile phone": "Téléphone mobile",
  "TVA number": "Numéro de TVA",
  "Address name": "Nom de l'adresse",
  "Country": "Pays",
  "City": "Ville",
  "Civility": "Civilité",
  "Edition supplier": "Édition du fournisseur",
  "Edition supplier contact": "Édition contact du fournisseur",
  "Edition supplier location": "Édition adresse du fournisseur",
  "Add an address": "Ajouter une adresse",
  "No order has been recorded yet": "Aucune commande n'a été enregistrée",
  "No supply has been recorded yet": "Aucun fournisseur n'a été enregistré",
  "No price list has been yet recorded": "Aucune grille tarifaire n'a été enregistrée",
  "No purchase price has been yet recorded": "Aucun prix d'achat n'a été enregistré",
  "No retail price has been yet recorded": "Aucun prix de vente n'a été enregistré",
  "Postal code": "Code postal",
  "This value must be at least {{min}} character(s).": "Cette valeur doit comporter au moins {{min}} caractères.",
  "This value must not be empty.": "Cette valeur ne doit pas être vide.",
  "This value must be less than or equal to {{max}}.": "Cette valeur doit être inférieure ou égale à {{max}}.",
  "This value is not a valid phone number.": "Cette valeur n'est pas un numéro de téléphone valide.",
  "This value must contain at least {{min}} item(s).": "Cette valeur doit contenir au moins {{min}} élément(s).",
  "Responsible": "Responsable",
  "Select a period": "Sélectionner une période",
  "select a period": "sélectionner une période",
  "Reset period": "Effacer la période",
  "All kinds": "Tous les types",
  "All reasons": "Toutes les raisons",
  "Refused": "Refusé",
  "Receiving": "En réception",
  "Received": "Réceptionné",
  "Accepted - Not received": "Accepté - Non réceptionné",
  "Received - To pay": "Réceptionné - À payer",
  "Received - Paid": "Réceptionné - Payé",
  "Loss": "Perte",
  "Theft": "Vol",
  "Damage": "Casse",
  "Tasting": "Dégustation",
  "Outdated DLUO": "DLUO dépassée",
  "Supplier trade in": "Reprise fournisseur",
  "Issue": "Émission",
  "Due": "Échéance",
  "See": "Voir",
  "Confirm the archiving of this supplier": "Confirmer l'archivage du fournisseur",
  "Confirm the archiving of this order": "Confirmer l'archivage de la commande",
  "Confirm the archiving of this variant": "Confirmer l'archivage de la variante",
  "Confirm the archiving of this product and its variants": "Confirmer l'archivage de ce produit et de ses variantes",
  "Once the order is archived, it will only be visible in the order list by applying the \"Archive\" filter.": "Une fois le bon de commande archivé, celui-ci sera uniquement visible dans la liste des commandes en appliquant le filtre “Archivé“.",
  "Once the variant is archived, it will only be visible in its product page and the catalog by applying the \"Archive\" filter.": "Une fois la variante archivée, celle-ci sera uniquement visible dans sa page produit et le catalogue en appliquant le filtre “Archivé“.",
  "Once the supplier is archived, it will only be visible in the supplier list by applying the \"Archive\" filter.": "Une fois le fournisseur archivé, celui-ci sera uniquement visible dans la liste des fournisseurs en appliquant le filtre “Archivé“.",
  "Confirm": "Confirmer",
  "Unarchive": "Désarchiver",
  "Wino did not respond, please reiterate your request.": "Wino n'a pas répondu, veuillez réitérer votre requête.",
  "The dashboard is currently unavailable due to a maintenance.": "L'application est actuellement inaccessible pour cause de maintenance.",
  "Wino will be back soon, thank you for your patience.": "Wino est bientôt de retour, merci de patienter.",
  "Refresh the page": "Recharger la page",
  "invalid purchasing price": "prix d'achat incorrect",
  "Couldn't import file.": "Le fichier n'a pas pu être importé.",
  "The imported file is too heavy.": "Le fichier importé excède le poids maximal autorisé.",
  "The imported file must be of type {{type}}.": "Veuillez vérifier que le fichier importé est au format {{type}}.",
  "The imported file must be of the following types: {{types}}.": "Veuillez vérifier que le fichier importé répond aux formats suivants : {{types}}.",
  "No address": "Pas d'adresse",
  "Address {{index}} |": "Adresse {{index}} |",
  "No contact": "Pas de contact",
  "You must enter at least the last name": "Vous devez renseigner au moins le nom de famille",
  "You must enter at least the name of the address": "Vous devez renseigner au moins le libellé de l'adresse",
  "Place": "Lieu",
  "Comment": "Commentaire",
  "Line": "Ligne",
  "Line No.": "N° ligne",
  "Location information not specified": "Adresse non renseignée",
  "Contact information not specified": "Contact non renseigné",
  "Total purchases incl.": "Total achat TTC",
  "Total purchased excl.": "Total achat HT",
  "Actions": "Actions",
  "Mr.": "M.",
  "Mrs.": "Mme",
  "Mister": "Monsieur",
  "Madam": "Madame",
  "Neutral": "Neutre",
  "Multi-shop": "Multi-boutique",
  "Select a shop": "Sélectionner une boutique",
  "Beware !": "Attention !",
  "Select the shop in charge of the order to start adding products.": "Sélectionner la boutique en charge de la commande pour démarrer l'ajout de produits.",
  "Shop name": "Nom de la boutique",
  "Define the shop for which the supplier will be created.": "Définissez la boutique pour laquelle le fournisseur sera créé.",
  "Beware ! Once the draft is saved, you will no longer be able to edit the shop.": "Attention ! Une fois le brouillon enregistré, vous ne pourrez plus modifier la boutique.",
  "Description not filled in": "Description non renseignée",
  "Generating PDF of order {{orderName}}": "Génération du PDF de la commande {{orderName}}",
  "Stock transfer": "Transfert de stock",
  "Stock transfers": "Transferts de stock",
  "Sender information": "Informations expéditeur",
  "Recipient information": "Informations destinataire",
  "Sender": "Expéditeur",
  "Select the sending shop": "Sélectionner la boutique émettrice",
  "Select the destination shop": "Sélectionner la boutique destinatrice",
  "Sender stock": "Stock expéditeur",
  "Recipient stock": "Stock destinataire",
  "Transferred quantity": "Quantité transférée",
  "Please select the shops linked to the transfer to start adding products.": "Veuillez sélectionner les boutiques liées au transfert pour démarrer l'ajout de produits.",
  "Add products to complete your transfer": "Ajouter des produits pour compléter votre transfert",
  "{{count}} products could not be added to the transfer because they are not common to the two selected shops.": "{{count}} produits n'ont pas pu être ajoutés au transfert car ils ne sont pas communs aux deux boutiques sélectionnées.",
  "{{count}} product could not be added to the transfer because it is not common to the two selected shops.": "{{count}} produit n'a pas pu être ajouté au transfert car il n'est pas commun aux deux boutiques sélectionnées.",
  "Loading products": "Chargement des produits",
  "Confirm the modification": "Confirmer la modification",
  "Changing the sender will reset the transfer basket.": "La modification de l'expéditeur entraînera la réinitialisation du panier de transfert.",
  "Changing the recipient will reset the transfer basket.": "La modification du destinataire entraînera la réinitialisation du panier de transfert.",
  "You should have at least one product in cart.": "Vous devez avoir au moins un produit dans votre panier.",
  "Incoming transfer": "Transfert entrant",
  "Outgoing transfer": "Transfert sortant",
  "All seized stocks were successfully transferred from {{sender}} to {{recipient}}!": "Tous les stocks saisis ont été transférés avec succès de {{sender}} à {{recipient}} !",
  "The seized stock was successfully transferred from {{sender}} to {{recipient}}!": "Le stock saisi a été transféré avec succès de {{sender}} à {{recipient}} !",
  "The cart contains products with an incorrect transferred quantity.": "Le panier comporte des produits avec une quantité transférée incorrecte.",
  "Transferred quantity must be greater than 0.": "La quantité transférée doit être supérieure à 0.",
  "General performances": "Performances générales",
  "Tickets revenue excl. VAT": "Chiffre d'affaires tickets HT",
  "Tickets revenue incl. VAT": "Chiffre d'affaires tickets TTC",
  "Invoices revenue excl. VAT": "Chiffre d'affaires factures HT",
  "Invoices revenue incl. VAT": "Chiffre d'affaires factures TTC",
  "Global revenue excl. VAT": "Chiffre d'affaires global HT",
  "Global revenue incl. VAT": "Chiffre d'affaires global TTC",
  "Number of sales": "Nombre de ventes",
  "Total amount of VAT": "Montant total TVA",
  "Margin": "Marge",
  "Average cart incl. VAT": "Panier moyen TTC",
  "Sales index": "Indice de vente",
  "Sold products": "Produits vendus",
  "New clients": "Nouveaux clients",
  "Every half hour": "Toutes les demis-heures",
  "Stock control": "Suivi de stock",
  "Maximum stock": "Stock maximum",
  "Minimum stock": "Stock mimimum",
  "Stock triggering the order": "Stock déclenchant la commande",
  "You have to define the maximum stock beforehand.": "Vous devez définir le stock maximum en amont.",
  "This value should be less than maximum stock value.": "Cette valeur doit être inférieure au stock maximum.",
  "The minimum stock should be less or equal to the value triggering a new order.": "Le stock minimum doit être inférieur ou égal à la valeur déclanchant une nouvelle commande.",
  "The minimum stock should be less than the maximum stock.": "Le stock minimum doit être inférieur au stock maximum.",
  "Performances per shop": "Performances par boutique",
  "Revenue excl. VAT": "CA HT",
  "Revenue incl. VAT": "CA TTC",
  "Avg. basket": "Panier moy.",
  "Products sold": "Produits vendus",
  "Top products sold": "Top des produits vendus",
  "Top product sold": "Top produit vendu",
  "Sold qt": "Qté vendue",
  "Turnover incl. VAT": "CA TTC",
  "All categories": "Toutes les categories",
  "excld. taxes": "HT",
  "Please fulfill this field.": "Veuillez remplir ce champ.",
  "a new wine": "un nouveau vin",
  "a new beer": "une nouvelle bière",
  "a new spirituous": "un nouveau spiritueux",
  "a new simple product": "un nouveau produit classique",
  "your variant": "votre variant",
  "a variant": "une variante",
  "No result for the country": "Aucun résultat pour le pays",
  "Reception:": "Réception :",
  "Issue:": "Émission :",
  "Export error": "Erreur pendant l'export",
  "Exporting": "Export en cours",
  "Download": "Télécharger",
  "minStockThreshold should be less than or equal to stockOrderTriggerThreshold.": "Le stock minimum doit être inférieur ou égal à la valeur déclanchant une nouvelle commande.",
  "minStockThreshold should be less than maxStockThreshold.": "Le stock minimum doit être inférieur au stock maximum",
  "stockOrderTriggerThreshold should be less than maxStockThreshold.": "La valeur déclanchant une nouvelle commande doit être inférieure au stock maximum.",
  "estimated": "estimée",
  "Invalid filters, change them!": "Filtres invalides, changez les !",
  "Custom": "Personnalisé",
  "Please select a date range!": "Veuillez sélectionner une période !",
  "Some changes in the retail prices have not been saved.": "Des modifications apportées aux prix de vente n'ont pas été enregistrées.",
  "Save prices": "Enregistrer les prix",
  "The retail prices have been successfully updated.": "Les prix de vente ont bien été mis à jour.",
  "Pick a date range": "Sélectionner une période",
  "Pick a date range*": "Sélectionner une période*",
  "Since the beginning": "Depuis le début",
  "You are not authenticated, please log in again.": "Vous n'êtes pas authentifiés, veuillez vous reconnecter.",
  "The label sheet has been successfully generated.": "La planche d'étiquettes a bien été générée.",
  "No active shop found": "Aucun magasin actif trouvé",
  "SKU: {{sku}}": "SKU : {{sku}}",
  "internal code: {{internalCode}}": "code interne : {{internalCode}}",
  "No retail prices found with the selected price list": "Aucun prix de vente trouvé avec la grille tarifaire sélectionnée",
  "This feature only works for catalogs\nwith less than 1,000 products": "Cette option ne fonctionne que pour les catalogues\nde moins de 1 000 produits.",
  "Download label PDF": "Télécharge PDF étiquettes",
  "Pending...": "En attente…",
  "Display border": "Afficher les traits de coupe",
  "Search a campaign": "Recherche une campagne",
  "Welcome to the catalog space.": "Bienvenue sur l'espace du catalogue.",
  "Welcome to the stock transfers space.": "Bienvenue sur l'espace des transferts de stock.",
  "Welcome to the suppliers space.": "Bienvenue sur l'espace des fournisseurs.",
  "Welcome to the supplier orders space.": "Bienvenue sur l'espace des commandes fournisseurs.",
  "Welcome to the stock movements space.": "Bienvenue sur l'espace des mouvements de stock.",
  "Welcome to the promotional campaigns space.": "Bienvenue sur l'espace des campagnes promotionnelles.",
  "Start creating your first campaign.": "Créez ici votre première campagne.",
  "Clear search query and filters": "Réinitialiser la recherche et les filtres",
  "Clear search query": "Réinitialiser la recherche",
  "Search a stock movement": "Rechercher un mouvement de stock",
  "It seems no data exists yet for this shop.": "Il semblerait qu'aucune donnée n'existe encore pour cette boutique.",
  "Top sold products": "Top des produits vendus",
  "Sold Quantity": "Qté vendue",
  "Try again with different filters.": "Tentez à nouveau avec des filtres différents.",
  "For {{value}}": "Pour {{value}}",
  "Sold quantity": "Quantité vendue",
  "Revenue": "Chiffre d'affaires",
  "List": "Liste",
  "Shops": "Boutiques",
  "Impersonate": "Usurper l'identité",
  "Impersonation": "Usurpation d'identité",
  "Impersonation — Test mode": "Usurpation — Test mode",
  "List of users": "Liste des utilisateurs",
  "Search an user": "Rechercher un utilisateur",
  "{{count}} shops": "{{count}} boutiques",
  "{{count}} shop": "{{count}} boutique",
  "Shop(s)": "Boutique(s)",
  "Name / organization": "Nom / organisation",
  "List of shops": "Liste des boutiques",
  "Search a shop": "Rechercher une boutique",
  "Copy the ID": "Copier l'ID",
  "Cost of sales": "Coût d'achat des ventes",
  "Your password has been reset successfully. Please log in": "Votre mot de passe a bien été mis à jour, vous pouvez vous connecter.",
  "The link has expired": "Le lien a éxpiré.",
  "Compare period to": "Comparer à",
  "Previous period": "Période précédente",
  "Previous year": "Année précédente",
  "Inventory Valuation": "Valeur de stocks",
  "Your account": "Votre compte",
  "To update your login credentials, you will need to enter your current password and confirm the changes through a link sent to your current email inbox.": "Pour mettre à jour vos identifiants de connexion, vous devrez saisir votre mot de passe actuel et confirmer vos modifications depuis un lien réceptionné sur votre boîte e-mail actuelle.",
  "The account name is the name that appears at the top of the interface menu. The username is your name that appears at the bottom of the menu.": "Le nom de compte est le nom qui s'affiche en haut du menu de l'interface. Le nom d'utilisateur est votre nom qui s'affiche en bas du menu.",
  "Account name and Username": "Nom de compte et d'utilisateur",
  "Update password": "Modifier le mot de passe",
  "Update email": "Modifier l'adresse e-mail",
  "Current password": "Mot de passe actuel",
  "Enter your current password": "Entrer votre mot de passe actuel",
  "Enter your new password": "Entrer votre nouveau mot de passe",
  "Confirm your new password": "Confirmer votre nouveau mot de passe",
  "Account name": "Nom du compte",
  "Username": "Nom d'utilisateur",
  "Your user and account information has been successfully updated.": "Vos informations d'utilisateur et de compte ont été modifiées avec succès.",
  "Wrong user password provided.": "Le mot de passe que vous avez donné n'est pas valide.",
  "Cannot run request": "Impossible de lancer la requête",
  "Your email address has been updated successfully.": "Votre adresse e-mail a été modifiée avec succès.",
  "Selected shop": "Boutique sélectionnée",
  "Select the store for which you want to view or modify information.": "Sélectionner la boutique pour laquelle vous souhaitez consulter ou modifier des informations.",
  "Banking information": "Informations bancaires",
  "General store information": "Informations générales de la boutique",
  "Bank name": "Nom de la banque",
  "Bank code": "Code de la banque",
  "Bank account holder": "Titulaire du compte bancaire",
  "Bank account number": "Numéro de compte bancaire",
  "BIC code": "Code BIC",
  "IBAN number": "Numéro IBAN",
  "This shop has been archived.": "Cette boutique a été archivée.",
  "This shop does not exist.": "Cette boutique n'existe pas.",
  "Corporate name": "Dénomination sociale",
  "Legal form": "Forme juridique",
  "Amount of share capital": "Montant du capital social",
  "City of registry office": "Ville d'immatriculation",
  "SIRET number": "Numéro de SIRET",
  "SIREN number": "Numéro de SIREN",
  "APE/NAF code": "Code APE/NAF",
  "VAT number": "Numéro de TVA",
  "RCS number": "Numéro RCS",
  "BCE number": "Numéro BCE",
  "RCSL number": "Numéro RCSL",
  "The BCE number must contain 10 digits.": "Le numéro BCE doit comporter 10 chiffres.",
  "This email address is already used.": "Cette adresse e-mail est déjà utilisée.",
  "Settings": "Paramètres",
  "No data to display for the selected period": "Aucune donnée à afficher pour la période sélectionnée",
  "The stock value is computed only on today's date": "La valeur de stock est calculée uniquement à la date d'aujourd'hui",
  "A link has been sent to you by email to proceed with the email address change.": "Un lien vous a été envoyé par e-mail afin de procéder au changement d'adresse e-mail.",
  "You will receive a link by email to confirm the email address change within a few minutes.": "Vous allez recevoir un lien par e-mail afin de confirmer le changement d'adresse e-mail d'ici quelques minutes.",
  "Email update": "Changement d'adresse e-mail",
  "Your email update has been completed successfully.": "Votre mise à jour d'adresse e-mail a été effectuée avec succès.",
  "Account successfully set up.": "Votre compte a bien été crée.",
  "Set Up Your Wino Account": "Créer votre compte Wino",
  "Login details": "Identifiants de connexion",
  "Please make a note of your password out of sight. This will solve a potential slight memory lapse when first logging into Wino!": "Noter votre mot de passe à l'abri des regards. Cela solutionnera une éventuelle petite perte de mémoire lors de la première connexion à Wino !",
  "Complete the store name and your contact information that will be displayed on your sales documents.": "Compléter le nom de la boutique et les coordonnées du magasin. Ces informations s'afficheront sur les documents de vente émis par le logiciel Wino.",
  "Shop Name & Contact": "Nom et contact de votre boutique",
  "Enter your shop's address; it'll be reflected in your official documents.": "Indiquer l'adresse de votre boutique. Elle apparaîtra sur vos documents émis sur app.wino.fr.",
  "Fill your legal information": "Compléter vos informations légales. Elles doivent obligatoirement être affichées sur vos documents.",
  "Enter your banking information. It will be shared with your customers for invoicing.": "Renseignez vos informations bancaires. Elles seront communiquées à vos clients pour la facturation.",
  "Belgium": "Belgique",
  "France - Mainland": "France - Métropole",
  "France - Corsica": "France - Corse",
  "France - Reunion Island": "France - Île de la Réunion",
  "France - French Guiana": "France - Guyane française",
  "France": "France",
  "Luxembourg": "Luxembourg",
  "Password confirmation": "Confirmation du mot de passe",
  "VAT applied (please note, this information cannot be changed)": "TVA appliquée (attention, cette information ne pourra pas être modifiée)",
  "anna.rossi@gmail.com": "anna.rossi@gmail.com",
  "Anna Rossi": "Anna Rossi",
  "Enter 14 digits": "14 chiffres à saisir",
  "Enter 10 digits": "10 chiffres à saisir",
  "Enter a code of 4 digits and one letter": "Code de 4 chiffres et une lettre à saisir",
  "FR 11 123123123": "FR 11 123123123",
  "contact@shop.com": "contact@boutique.fr",
  "This address will be used for billing our services. It will also appear on your sales documents issued by the Wino software. If needed, it can be changed later within the software.": "Cette adresse sera utilisée pour la facturation de nos services. Elle apparaîtra également sur vos documents de vente émis avec le logiciel Wino. Elle pourra si besoin être modifiée ultérieurement dans le logiciel.",
  "Société Générale": "Société Générale",
  "Create your account": "Créer le compte",
  "These details will be used for billing our services. They will also appear on your sales documents issued by the Wino software.": "Ces informations seront utilisées pour la facturation de nos services. Elles apparaîtront également sur les documents de vente émis par le logiciel Wino.",
  "Company name as displayed on your official business registration document.": "Nom de l'entreprise affiché sur votre Kbis",
  "Search your company": "Rechercher votre entreprise",
  "Search your company to fill in": "Rechercher votre entreprise pour remplir",
  "Other country": "Autre pays",
  "Legal information": "Informations légales",
  "Employees number": "Nombre d'employés",
  "Select a number of employees": "Sélectionner un nombre d'employés",
  "Legal and tax identification": "Identification légale et fiscale",
  "Other tax information": "Autres informations fiscales",
  "Fiscal year end closing month": "Mois de clôture de l'exercice financier",
  "Select a month": "Sélectionner un mois",
  "Current fiscal year:": "Exercice financier en cours :",
  "from {{startDate}} to {{endDate}}": "du {{startDate}} au {{endDate}}",
  "This setting will automatically be taken into account when creating your next annual Z, to ensure correct calculations over the reference period.": "Ce paramétrage sera automatiquement pris en compte lors de la création de votre prochain Z annuel, afin d'assurer les bons calculs sur la période de référence.",
  "Postal address": "Adresse postale",
  "Enter your address. It will appear on your documents issued on app.wino.fr": "Indiquez votre adresse. Elle apparaîtra sur vos documents émis sur app.wino.fr",
  "Shop website": "Site web de la boutique",
  "Shop email address": "Adresse e-mail de la boutique",
  "The IBAN number is not valid.": "L'IBAN n'est pas valide, veuillez vérifier.",
  "For your country, carefully select the proposal corresponding to your situation. Your choice will determine the VAT settings on your account.": "Pour le pays France, sélectionner avec attention la proposition correspondant à votre situation. Votre choix conditionnera le paramétrage de la TVA sur votre compte.",
  "Account creation": "Création de votre compte",
  "User account creation": "Création du compte utilisateur",
  "Subscription setup": "Configuration de votre abonnement",
  "Configuring devices": "Configuration des différentes appareils",
  "Tax creation": "Création des taxes",
  "Validating your payment method": "Validation de votre moyen de paiement",
  "By providing your IBAN and clicking on 'Create account' from this URL, you authorize Wino Technologies and Stripe, our payment service provider, to send instructions to your bank to debit your account and your bank to debit your account in accordance with these instructions. You are entitled to a refund from your bank under the terms and conditions of the agreement you have entered into with them. The refund must be requested within 8 weeks from the date your account was debited.": "En fournissant votre IBAN et en cliquant sur « Créer le compte » depuis cette URL, vous autorisez Wino Technologies et Stripe, notre prestataire de services de paiement, à envoyer des instructions à votre banque pour débiter votre compte et votre banque à débiter votre compte conformément à ces instructions. Vous avez droit à un remboursement de la part de votre banque selon les termes et conditions de l'accord que vous avez conclu avec elle. Le remboursement doit être demandé dans un délai de 8 semaines à compter de la date à laquelle votre compte a été débité.",
  "🎉 Your account has been created successfully!": "🎉 Votre compte a été créé avec succès !",
  "A confirmation email will be sent to you in the next few minutes. Our team will contact you soon to set up the software. You can now close this window.": "Un e-mail de confirmation va vous être envoyé. Notre équipe vous contactera prochainement pour la mise en place du logiciel. Vous pouvez à présent fermer cette fenêtre.",
  "Please check your information, some fields are incorrect.": "Veuillez vérifier vos informations, certains champs sont incorrects.",
  "How to contact us? By email at hello@wino.fr": "Comment nous contacter ? Par e-mail à hello@wino.fr",
  "Guest": "Invité",
  "The VAT number is not valid.": "Le numéro de TVA n'est pas valide.",
  "The legal representative is not valid, full name must be given.": "Le représentant légal n'est pas valide, le nom complet doit être fourni.",
  "The corporate name is invalid. Please provide the full name of the company.": "La dénomination sociale n'est pas valide. Veuillez fournir le nom complet de l'entreprise.",
  "Cannot decode {{trace}}": "Impossible d'analyser {{trace}}",
  "at line {{index}}": "à la ligne {{index}}",
  "{{json}} at line {{index}}": "{{json}} à la ligne {{index}}",
  "Wino could not proceed to the inventory import, please try again.": "Wino n'a pas pu procéder à l'import de l'inventaire, veuillez réessayer.",
  "Please ensure that the inventory file is correct: it is currently empty, no rows have been found.": "Veuillez vous assurer que le fichier d'inventaire est correct : il est actuellement vide, aucune ligne n'a été trouvée.",
  "Please ensure that the inventory file is correct. Errors have been identified on the header row: the columns '{{A}}' and/or '{{B}}' cannot be found.": "Veuillez vous assurer que le fichier d'inventaire est correct. Des erreurs ont été identifiées sur la ligne d'en-tête : les colonnes '{{A}}' et/ou '{{B}}' sont introuvables.",
  "Please ensure that the inventory file is correct, the '{{column}}' column is empty.": "Veuillez vous assurer que le fichier d'inventaire est correct, la colonne '{{column}}' est vide.",
  "Please ensure that the inventory file is correct, as an error has been reported during its analysis.": "Veuillez vous assurer que le fichier d'inventaire est correct, une erreur est survenue au moment de son analyse.",
  "Negative inventory quantity {{trace}}": "Quantité inventaire négative {{trace}}",
  "Inventory quantity missing at line {{line}}": "Quantité inventaire manquante à la ligne {{line}}",
  "Reference ID missing at line {{line}}": "ID de la référence manquant à la ligne {{line}}",
  "Incorrect or corrupted inventory quantity at decimals {{trace}}, please re-enter the value.": "Quantité inventaire invalide ou corrompue après la virgule {{trace}}, veuillez resaisir sa valeur.",
  "Incorrect reference ID {{trace}}": "ID de la référence erroné {{trace}}",
  "Incorrect inventory quantity {{trace}}": "Quantité inventaire erronée {{trace}}",
  "several occurrences of the ID {{trace}} are present in the file.": "plusieurs occurrences de l'ID {{trace}} sont présentes dans le fichier.",
  "Subscription and billing": "Abonnement et facturation",
  "No payment": "Aucun paiement",
  "Payments": "Paiements",
  "Payment method": "Mode de paiement",
  "Payment methods": "Modes de paiement",
  "SEPA direct debit": "Prélèvement SEPA",
  "Age not provided": "Âge non renseigné",
  "Customer tenure": "Ancienneté du client",
  "Your payment mandate is currently being validated.": "Votre mandat de paiement est en cours de validation.",
  "Your internet connection has been interrupted, please reload the page before submitting the form again.": "Votre connexion internet a été interrompue, veuillez recharger la page avant de soumettre à nouveau le formulaire.",
  "Getting started guide": "Guide de démarrage",
  "Changes made successfully.": "Changements effectués avec succès.",
  "Invoice history": "Historique des factures",
  "No invoice could be found.": "Aucune facture n'a pu être trouvée.",
  "Amount due": "À payer",
  "Paid via credit note": "Soldé par avoir",
  "Amount": "Montant",
  "Seach an invoice": "Rechercher une facture",
  "Search an invoice": "Rechercher une facture",
  "Sorry, no invoices were found.": "Désolé, aucune facture n'a été trouvée.",
  "No data available": "Aucune donnée disponible",
  "Review the terms and conditions of sale.": "Consulter les conditions générales de vente",
  "Subscription": "Abonnement",
  "Standard": "Standard",
  "Company": "Entreprise",
  "Boost": "Boost",
  "Unable to display information about your subscription.": "Impossible d'afficher les informations concernant votre abonnement.",
  "Would you like to change your subscription?": "Vous souhaitez changer d'abonnement ?",
  "Discover our subscriptions.": "Découvrir nos abonnements.",
  "Next charge on": "Prochain prélèvement le",
  "Customer support": "Support client",
  "Support": "Support",
  "Unable to display information regarding your billing.": "Impossible d'afficher les informations concernant votre facturation.",
  "Unable to display information regarding your payment method.": "Impossible d'afficher les informations concernant votre moyen de paiement.",
  "Invoices unavailable at the moment.": "Factures indisponibles pour le moment.",
  "Export customer file": "Exporter le fichier client",
  "Meanwhile, you can still export them.": "En attendant, vous pouvez toujours les exporter.",
  "The display of customer contacts is not yet available.": "L'affichage des contacts clients n'est pas encore disponible.",
  "SA": "SA",
  "SAS": "SAS",
  "SARL": "SARL",
  "EI": "EI",
  "EIRL": "EIRL",
  "EURL": "EURL",
  "MICRO": "Micro/auto entreprise",
  "SNC": "SNC",
  "SCS": "SCS",
  "SCA": "SCA",
  "Show all invoices": "Afficher toutes les factures",
  "Sales journal": "Journal des ventes",
  "Displaying receipts and invoices is not yet available.": "L'affichage des tickets de caisse et des factures n'est pas encore disponible.",
  "In the meantime, you can still export them. The file also includes refunds and credits.": "En attendant, vous pouvez toujours les exporter. Le fichier contient également les remboursements et avoirs.",
  "sales_list_page.title": "Facturation & encaissement",
  "Type of sales": "Type de ventes",
  "From {{startDate}} to {{endDate}}": "Du {{startDate}} au {{endDate}}",
  "On {{date}}": "Le {{date}}",
  "Invoices and credit notes": "Factures et avoirs",
  "Export the document": "Exporter le document",
  "Your SEPA direct debit authorization has been successfully confirmed.": "Votre autorisation de prélèvement SEPA a été confirmée avec succès.",
  "The file has been downloaded successfully.": "Le fichier a été téléchargé avec succès.",
  "Your synchronization is suspended due to the lack of SEPA mandate validation": "Votre synchronisation est suspendue en raison de l'absence de confirmation du mandat SEPA",
  "Accounting entries": "Écritures comptables",
  "Export my accounting entries": "Exporter mes écritures comptables",
  "Account setup": "Configuration des comptes comptables",
  "Learn more about accounting entries": "Comment paramétrer puis exporter mes écritures comptables ?",
  "accounting_configuration.setting_tax_rates.title": "Configuration du journal des ventes",
  "accounting_configuration.setting_payments.title": "Configuration du journal des règlements",
  "accounting_configuration.setting_payments.description": "Au sein de cette section, vous allez pouvoir définir les comptes comptables associés à chaque méthode de paiement.",
  "accounting_configuration.settings_general.title": "Configuration générale",
  "accounting_configuration.settings_general.description": "Cette section vous permet de configurer les paramètres généraux de vos écritures comptables.",
  "Agiris file number": "Numéro de dossier Agiris",
  "Fiscal year (per month of opening)": "Exercice fiscal (par mois d'ouverture)",
  "Tax account": "Compte comptable TVA",
  "Product account": "Compte comptable produit",
  "Setup my accounting accounts": "Paramétrer mes comptes comptables",
  "January": "Janvier",
  "February": "Février",
  "March": "Mars",
  "April": "Avril",
  "May": "Mai",
  "June": "Juin",
  "July": "Juillet",
  "August": "Août",
  "September": "Septembre",
  "October": "Octobre",
  "November": "Novembre",
  "December": "Décembre",
  "IsaCompta file number": "N° de dossier IsaCompta",
  "VAT rate": "Taux de TVA",
  "Non-deductible VAT": "TVA non déductible",
  "Used for overseas sales": "Utilisé pour les ventes à l'étranger.",
  "Autocomplete with accounting standard": "Auto-compléter avec l'étalon comptable",
  "Autocomplete": "Auto-compléter",
  "accounting.configuration_page.help_with_accouting_standard": "Il semble qu’aucun compte comptable ne soit encore enregistré dans cette section.\nVous pouvez, si vous le souhaitez, remplir automatiquement les champs\nen utilisant un étalon comptable standard :",
  "accounting.configuration_page.setting_payments.help_with_autocomplete": "Il semble qu’aucun compte comptable ne soit encore enregistré dans cette section.\nVous pouvez, si vous le souhaitez, remplir automatiquement les comptes comptables\npour les méthodes de paiements principales :",
  "Associated label": "Libellé associé",
  "Goods account": "Compte comptable marchandise",
  "IsaCompta code": "Code IsaCompta",
  "The configuration has been successfully saved": "Vos paramètres ont été enregistrés avec succès",
  "accounting_configuration.setting_tax_rates.description": "Dans cette section, vous pouvez configurer les comptes comptables liés à la gestion de la TVA déductible ainsi qu’à la vente de marchandises ou de biens. Ces paramètres vous permettent de garantir une comptabilité précise, en associant les bons comptes à chaque type de transaction.",
  "accounting_main.description": "Assurez-vous avant que vos comptes sont correctement configurés\npour un suivi comptable précis :",
  "Your accounting entries have been successfully exported.": "Vos écritures comptables ont été exportées avec succès.",
  "accounting.not_found_accounting_configuration_failure": "Assurez-vous que vos comptes comptables sont correctement configurés avant de procéder à un export.",
  "accounting.missing_configuration_for_isacompta_vendor_failure": "Assurez-vous que vos comptes comptables pour IsaCompta sont correctement configurés avant de faire un export.",
  "accounting.missing_payment_method_account_failure{{paymentMethod}}": "Attention, vous n'avez pas défini de compte comptable pour les règlements par {{paymentMethod}}.",
  "Breakdown of sales to consumers": "Ventilation des ventes aux particuliers",
  "Display of daily cash register reports instead of receipts": "Si cette option est cochée, les ventes seront détaillées par ticket de caisse.\nSinon, le détail se fera par journal de caisse.",
  "accounting_configuration.setting_cashflow.title": "Configuration du journal de caisse",
  "accounting_configuration.setting_cashflow.description": "Cette section détaille les comptes comptables liés aux mouvements de caisse (=entrées/sorties de caisse). Ces comptes comptables ne sont pas éditables.",
  "Cash flow accounting account": "Compte comptable caisse",
  "Cash flow label account": "Libellé du compte caisse",
  "Internal transfer account": "Compte comptable virement interne",
  "Internal transfer label account": "Libellé du compte virement interne",
  "accounting.invalid_sale_tax_failure{{name}}{{issueDate}}": "Attention : Le document de vente N°{{name}}, émis le {{issueDate}}, est incomplet et ne peut être traité.\n\nEn effet, certains documents de vente émis avec l’application de caisse en version inférieure à 1.34.0\nou sur dashboard.wino.fr avant le 15/02/2025 peuvent être incompatibles à l'export.",
  "The selected date range exceeds the boundaries of the fiscal year. Please ensure your start and end dates fall within a fiscal year.": "La plage de dates sélectionnée ne doit pas chevaucher plusieurs années fiscales. Veuillez vous assurer que les dates de début et de fin se situent dans la même année fiscale.",
  "Payment link": "Lien de paiement",
  "Pay now": "Payer maintenant",
  "Your payment has been successfully processed. You can now fully enjoy our services.": "Votre paiement a été traité avec succès. Vous pouvez désormais profiter pleinement de nos services.",
  "We were unable to complete your payment due to a technical error. Please try again or contact us for assistance.": "Nous n'avons pas pu finaliser votre paiement en raison d'une erreur technique. Merci de réessayer ou de nous contacter pour assistance.",
  "Negative cash difference label account": "Libellé du compte comptable écarts de caisse négatifs",
  "Negative cash difference account": "Compte comptable écarts de caisse négatifs",
  "Positive cash difference label account": "Libellé du compte comptable écarts de caisse positifs",
  "Positive cash difference account": "Compte comptable écarts de caisse positifs",
  "please settle your account as soon as possible to avoid suspension of your account": "veuillez régulariser votre situation au plus vite pour éviter la suspension de votre compte",
  "Return to export interface": "Revenir à l'interface d'export",
  "Journal code": "Code journal",
  "accounting_configuration.setting_cashflow.journal_code.tooltip": "Le x est remplacé par le numéro de caisse. La caisse A01 aura le code journal C01, la caisse A02 aura le code journal C02 ... jusqu'à C09.",
  "accounting_configuration.setting_cashflow.internal_transfer_account.tooltip": "Utilisé pour les entrées/sorties manuelles de caisse.",
  "accounting_configuration.setting_payments.cash_accounting_account_tooltip": "Utilisé uniquement dans le cas de ventes aux professionnels.\nDans le cas de ventes aux particuliers, le compte de caisse 53000000 sera utilisé",
  "accounting_configuration.setting_payments.isacompta_journal_code_tooltip": "Utilisé uniquement dans le cas de ventes aux professionnels.\nDans le cas de ventes aux particuliers, le code journal C1, C2 etc. sera utilisé",
  "If checked, the payment journal will be exported.": "Si cette option est cochée, le journal des règlements sera exporté.",
  "Add": "Ajouter",
  "IsaCompta journal code": "Code journal IsaCompta",
  "Payment {{paymentMethod}}": "Paiement {{paymentMethod}}",
  "This field must contain {{length}} characters.": "Ce champ doit contenir {{length}} caractères.",
  "This field must be unique; the value {{value}} has already been entered.": "Ce champ doit être unique, la valeur {{value}} est déjà saisie.",
  "This field should be of format {{pattern}}.": "Ce champ doit être du format {{pattern}}.",
  "This field must contain {{length}} characters": "Ce champ doit contenir {{length}} caractères",
  "This field must contain between {{minLength}} and {{maxLength}} characters.": "Ce champ doit contenir entre {{minLength}} et {{maxLength}} caractères.",
  "If this option is checked, cash payments will be recorded in the cash journal.\n Otherwise it will be recorded in the payments journal.": "Si cette option est cochée, les paiements en espèces seront enregistrés dans le journal de caisse.\nSinon, ils seront enregistrés dans le journal des règlements.",
  "Cash payments in payments journal": "Gestion des paiements en espèces",
  "Pending action": "Action en attente",
  "New customers": "Nouveaux clients",
  "New customers with loyalty": "Nouveaux clients avec fidélité",
  "Customers (loyalty)": "Clients (fidélité)",
  "cash_register_archive_verify_page.header.title": "Vérification de votre archive de caisse",
  "cash_register_archive_verify_page.header.subtitle_1": "Déposez ci-dessous votre archive de données de caisse générée par l’application de caisse Wion POS afin de vérifier son authenticité et intégrité.",
  "cash_register_archive_verify_page.header.subtitle_2": "Cette interface peut être utilisée aussi bien par le commerçant lui même utilisateur de la solution Wino que par l’administration fiscale dans le cadre d’un contrôle.",
  "cash_register_archive_verify_page.header.subtitle_3": "Pour rappel, la solution Wino ne stocke pas vos archives : il vous appartient de les conserver après leur génération dans l’application Wino POS.",
  "cash_register_archive_verify_page.header.subtitle_link": "Plus d'informations à ce sujet ici.",
  "cash_register_archive_verify_page.file_card.title": "Fichier d'archive de caisse",
  "cash_register_archive_verify_page.file_card.inline_text_1": "Glisser et déposer ou choisir votre fichier",
  "cash_register_archive_verify_page.file_card.inline_text_2": "Nous vérifierons automatiquement qu’il s’agit d’une archive conforme et qu’elle n’a subi aucune modification depuis sa génération.",
  "cash_register_archive_verify_page.request_ok.valid_file": "L’archive est intègre et authentique. L'archive de caisse générée par Wino POS est donc conforme.",
  "cash_register_archive_verify_page.request_error.invalid_file": "L’archive n’a pas été validée. Un problème d’intégrité ou d’authenticité a été détecté. Seules les archives générées directement par Wino POS peuvent être vérifiées ici.",
  "cash_register_archive_verify_page.request_error.something_wrong_happened_we_could_not_check_the_file": "Un problème est survenu et nous n'avons pas pu vérifier l'authenticité de votre archive de caisse. Veuillez réessayer ultérieuement.",
  "Top staffs": "Top vendeurs",
  "Shopping cart average": "Panier moyen",
  "Revenue exc. VAT/inct. VAT": "CA HT/TTC",
  "Logo placeholder": "Logo temporaire",
  "Enter your shop name and contact information.\n\nImport your logo / image via the button. The visual will be used automatically on your professional emails and invoices.\nYou can modify it at any time.": "Renseignez votre nom de magasin et vos informations de contact.\n\nImportez votre logo / image via le bouton. Le visuel sera utilisé automatiquement sur vos emails professionnels et vos factures.\nVous pourrez le modifier à tout moment.",
  "Drag and drop your image": "Glissez / déposez votre image",
  "Max. weight: 200 KB · Formats: JPEG and PNG": "Poids max. : 200 Ko · Formats : JPEG et PNG",
  "Square format recommended · Minimum width: 800 px": "Format carré recommandé · Largeur minimale : 800 px",
  "Select an image": "Sélectionner une image",
  "Failed to upload logo. Please try again or contact the support.": "Échec du téléchargement du logo. Veuillez réessayer ou contacter le support.",
  "Your shop changes have been saved successfully.": "Les modifications de votre boutique ont bien été enregistrées.",
  "Your shop information has been updated successfully.": "Les informations de votre boutique ont été mises à jour avec succès.",
  "invoicing_address.invalid_format.fr": "Format d'adresse de facturation électronique invalide. Format attendu : 0225:SIREN ou 0225:SIREN_SUFFIXE ou 0225:SIREN_SIRET ou 0225:SIREN_SIRET_CODEROUTAGE",
  "invoicing_address.invalid_format.be": "Format d'adresse de facturation électronique invalide. Format attendu : 0208:BCE ou 9925:VAT",
  "invoicing_address.label": "Adresse de facturation électronique",
  "Invoicing information": "Informations de facturation",
  "Complete your invoicing endpoint information.": "Complétez votre adresse de facturation électronique.",
  "Unable to load data": "Impossible d'afficher la donnée pour le moment",
  "Click to display more details": "Cliquez pour afficher plus de détails",
  "feature_is_enabled_badge_label": "Activée",
  "customer_list_page.filters.select_type.individual_kind.label": "Particulier (sans fidélité)",
  "Individual + loyalty": "Particulier + fidélité",
  "Unregistered customers": "Clients non enregistrés",
  "Registered customer": "Client enregistré",
  "Unregistered customer": "Client non enregistré",
  "Walk-in customer": "Client de passage",
  "Walk-in customers": "Clients de passage",
  "Confirm the archiving of this customer": "Confirmer l'archivage de ce client",
  "Confirm the unarchiving of this customer": "Confirmer le désarchivage de ce client",
  "Once the customer is archived, it will only be visible in the customer list by applying the \"Archived\" status filter.": "Une fois le client archivé, il ne sera visible dans la liste des clients qu'en appliquant le filtre de statut « Archivé ».",
  "Once the customer is unarchived, it will be visible again in the customer list.": "Une fois le client désarchivé, il sera de nouveau visible dans la liste des clients.",
  "Create customer": "Créer client",
  "Customer type": "Type de client",
  "Date of birth": "Date de naissance",
  "Internal note": "Note interne",
  "myaddress@email.com": "monadresse@email.fr",
  "customer_new_page.kind_fieldset.description": "Choisissez si le client est un particulier ou un professionnel.",
  "Edit the address": "Modifier l'adresse",
  "Mobile number": "Numéro de portable",
  "Intracommunity VAT number": "Numéro de TVA Intra-communautaire",
  "company_combobox.input_placeholder": "Rechercher par dénomination sociale ou SIRET",
  "No French company suggestion": "Aucune suggestion d'entreprise Française",
  "Head office": "Siège social",
  "Add a note": "Ajouter une note",
  "customer_new_page.addresses_fieldset.description": "Ajoutez les adresses de facturation et de livraison du client.",
  "customer_addresses_field.editor.new_modal_title": "Création d'adresse",
  "customer_addresses_field.editor.edit_modal_title": "Édition d'adresse",
  "customer_addresses_field.editor.billing_toggle_label": "Adresse de Facturation",
  "customer_addresses_field.editor.delivery_toggle_label": "Adresse de Livraison",
  "customer_addresses_field.editor.add_submit_button_label": "Ajouter adresse",
  "customer_addresses_field.editor.edit_submit_button_label": "Modifier adresse",
  "customer_addresses_field.editor.billing_replacement_warning": "Une adresse de facturation est déjà renseignée.\nIl ne peut y en avoir qu'une seule : celle-ci la remplacera.",
  "customer_addresses_field.editor.use_recipient_placeholder_action": "Utiliser ce nom",
  "customer_addresses_field.remove_confirmation_modal.title": "Confirmer la suppression de l'adresse",
  "customer_addresses_field.remove_confirmation_modal.text": "Cette adresse sera définitivement supprimée de la fiche du client.",
  "customer_new_page.information_fieldset.description": "Complétez les informations essentielles de votre client.",
  "Clear": "Effacer",
  "customer_new_page.billing_fieldset.description": "Renseignez les identifiants de facturation du client.",
  "customer_new_page.billing_fieldset.bce_already_used": "Ce numéro BCE est déjà utilisé par un autre client.",
  "customer_new_page.billing_fieldset.vat_already_used": "Ce numéro de TVA intracommunautaire est déjà utilisé par un autre client.",
  "customer_new_page.billing_fieldset.vat_invalid_format": "Ce numéro de TVA intracommunautaire n'est pas valide.",
  "customer_new_page.billing_fieldset.invoicing_endpoint.prefix_select.label": "Type adresse fact. électronique",
  "customer_new_page.billing_fieldset.invoicing_endpoint.prefix_select.section_title": "Préfixes adresse",
  "customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siren": "0225 - Siren",
  "customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siren_with_suffix": "0225 - Siren avec suffixe",
  "customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siret": "0225 - Siret",
  "customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siret_with_routing_code": "0225 - Siret avec code de routage",
  "customer_new_page.billing_fieldset.invoicing_endpoint.suffix_input.label": "Suffixe",
  "customer_new_page.billing_fieldset.invoicing_endpoint.suffix_input.placeholder": "Lettres et chiffres",
  "customer_new_page.billing_fieldset.invoicing_endpoint.routing_code_input.label": "Code routage",
  "customer_new_page.billing_fieldset.invoicing_endpoint.routing_code_input.placeholder": "Lettres et chiffres",
  "customer_new_page.billing_fieldset.invoicing_endpoint.derived_warning": "L'adresse est dérivée des identifiants de facturation, mais son exactitude doit être vérifiée avec le client.",
  "customer_new_page.billing_fieldset.invoicing_endpoint.be_label": "0208 - Numéro BCE",
  "customer_new_page.billing_fieldset.invoicing_endpoint.be_vat_label": "9925 - Numéro de TVA",
  "customer_new_page.misc_fieldset.description": "Ajoutez des informations internes à votre boutique, non visibles par le client.",
  "customer_new_page.price_fieldset.description": "Indiquez la grille tarifaire appliquée à ce client lors de ses achats.",
  "Statistics": "Statistiques",
  "Available points": "Points disponibles",
  "Ready to use": "Prêts à l'emploi",
  "Soon expiring": "Bientôt expirés",
  "Recent gains": "Gains récents",
  "Recent spending": "Dépenses récentes",
  "Last 3 months": "3 derniers mois",
  "Last 6 months": "6 derniers mois",
  "Locked rewards": "Récompenses verrouillées",
  "Points cost": "Coût en points",
  "Visits cooldown": "Visites avant réutilisation",
  "Resets points": "Remise à zéro des points",
  "Points": "Points",
  "Visits": "Visites",
  "Progress": "Progression",
  "Loyalty history": "Historique fidélité",
  "Reward": "Récompense",
  "loyalty.activity_kind.gain": "Gain",
  "loyalty.activity_kind.loss": "Perte",
  "loyalty.activity_kind.reset": "Réinitialisation",
  "loyalty.activity_reason.reward_used": "Récompense utilisée",
  "loyalty.activity_reason.welcome_points": "Points de bienvenue",
  "loyalty.activity_reason.reward_reset": "Réinitialisation après récompense",
  "loyalty.activity_reason.manual": "Modification manuelle",
  "loyalty.activity_reason.purchase": "Achat",
  "loyalty.activity_reason.return": "Retour",
  "No action available": "Aucune action disponible",
  "See sales receipt": "Voir ticket de caisse",
  "No.": "N°",
  "cash_register_report.kind.daily": "Quotidien",
  "cash_register_report.kind.daily_plural": "Quotidiens",
  "cash_register_report.kind.monthly": "Mensuel",
  "cash_register_report.kind.monthly_plural": "Mensuels",
  "cash_register_report.kind.yearly": "Annuel",
  "cash_register_report.kind.yearly_plural": "Annuels",
  "cash_register_report.status.open": "Ouvert",
  "cash_register_report.status.closed": "Clôturé",
  "cash_register_report.status.archived": "Archivé",
  "cash_register_report_pdf.generating": "Génération du PDF du journal de caisse {{name}}",
  "cash_register_reports_list_page.title": "Journaux de caisse",
  "cash_register_reports_list_page.export_request.pending": "Génération du fichier Excel en cours…",
  "cash_register_reports_list_page.export_request.unexpected_failure": "Une erreur inattendue est survenue lors de la tentative de téléchargement du fichier du journal de caisse.",
  "Opening date": "Date ouverture",
  "Closing date": "Date fermeture",
  "Opened on": "Ouvert le",
  "Opened by": "Ouvert par",
  "Closed on": "Fermé le",
  "Closed by": "Fermé par",
  "cash_register_reports_list_page.table.opened_column.title": "Ouvert",
  "cash_register_reports_list_page.table.time_and_staff_sublabel": "à {{time}} par {{staff}}",
  "cash_register_reports_list_page.table.closed_column.title": "Fermé",
  "Sales receipts range": "Intervalle tickets"
}
